import React, { useRef, useEffect, useState, useCallback } from "react";
import Toolbar from "@mui/material/Toolbar";
import Typography from "@mui/material/Typography";
import IconButton from "@mui/material/IconButton";
import Box from "@mui/material/Box";
import SearchIcon from "@mui/icons-material/Search";
import Autocomplete from "@mui/material/Autocomplete";
import TextField from "@mui/material/TextField";
import List from "@mui/material/List";
import ListItem from "@mui/material/ListItem";
import ListItemText from "@mui/material/ListItemText";
import { createTheme } from "@mui/material";
import CssBaseline from "@mui/material/CssBaseline";
import AppBar from "@mui/material/AppBar";
import MenuIcon from "@mui/icons-material/Menu";
import { alpha } from "@mui/material/styles";
import makeStyles from "@mui/styles/makeStyles";
import axios from "axios";
import LinearProgress from "@mui/material/LinearProgress";
import { format, parseISO } from "date-fns";
import Menu from "@mui/material/Menu";
import MenuItem from "@mui/material/MenuItem";
import MoreVertIcon from "@mui/icons-material/MoreVert";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";
import Grid from "@mui/material/Grid";
import { ThemeProvider, StyledEngineProvider } from "@mui/material/styles";
import LocalizationProvider from "@mui/lab/LocalizationProvider";
import MobileDatePicker from "@mui/lab/MobileDatePicker";
import AdapterDateFns from "@mui/lab/AdapterDateFns";
import EventIcon from "@mui/icons-material/Event";
import InputAdornment from "@mui/material/InputAdornment";
import Button from "@mui/material/Button";
import FormControlLabel from "@mui/material/FormControlLabel";
import FormControl from "@mui/material/FormControl";
import Radio from "@mui/material/Radio";
import RadioGroup from "@mui/material/RadioGroup";
import Paper from "@mui/material/Paper";

import CloseIcon from "@mui/icons-material/Close";
import EditIcon from "@mui/icons-material/Edit";
import PrintIcon from "@mui/icons-material/Print";
import PictureAsPdfIcon from "@mui/icons-material/PictureAsPdf";
import FileDownloadIcon from "@mui/icons-material/FileDownload";
import ListItemButton from "@mui/material/ListItemButton";
import LocalShippingIcon from "@mui/icons-material/LocalShipping";
import AddShoppingCartIcon from "@mui/icons-material/AddShoppingCart";

import Papa from "papaparse";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableRow from "@mui/material/TableRow";
import TableHead from "@mui/material/TableHead";
import Checkbox from "@mui/material/Checkbox";

import PropTypes from "prop-types";
import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";
import Divider from "@mui/material/Divider";

// PDF
import { jsPDF } from "jspdf";
import "jspdf-autotable";

import VanAccountItems from "./VanAccountTransactions/VanAccountItems";

const drawerWidth = 300;

const materialTheme = createTheme({
  // set default for now
});

const useStyles = makeStyles((theme) => ({
  appBar: {
    [theme.breakpoints.up("sm")]: {
      width: `calc(100% - ${drawerWidth}px)`,
      marginLeft: drawerWidth,
    },
  },
  menuButton: {
    marginRight: theme.spacing(2),
    [theme.breakpoints.up("sm")]: {
      display: "none",
    },
  },
  search: {
    position: "relative",
    borderRadius: theme.shape.borderRadius,
    backgroundColor: alpha(theme.palette.common.white, 0.15),
    "&:hover": {
      backgroundColor: alpha(theme.palette.common.white, 0.25),
    },
    marginRight: theme.spacing(2),
    marginLeft: 0,
    width: "100%",
    [theme.breakpoints.up("sm")]: {
      marginLeft: theme.spacing(3),
      width: "auto",
    },
    roota: {
      ...theme.typography.button,
      backgroundColor: theme.palette.background.paper,
      padding: theme.spacing(1),
    },
  },
  flexGrow: {
    flexGrow: 1, // This pushes the menu to the right
  },

  paper: {
    display: "flex",
    flexWrap: "wrap",
    "& > *": {
      margin: theme.spacing(1),
      width: "100%",
      padding: ".2rem",
    },
  },

  printBtn: {
    color: "#1976d2 !important",
  },
}));
// const filter = createFilterOptions();

const stepperCustomStyle = createTheme({
  components: {
    MuiStepLabel: {
      styleOverrides: {
        label: {
          color: "black", // default color for step label
          "&.Mui-active": {
            color: "#074173", // color for active step label
          },
          "&.Mui-completed": {
            color: "#0D9276", // color for completed step label
          },
        },
      },
    },
    MuiStepIcon: {
      styleOverrides: {
        root: {
          "&.Mui-active": {
            color: "#074173", // color for active step icon
          },
          "&.Mui-completed": {
            color: "#0D9276", // color for completed step icon
          },
        },
      },
    },
  },
});

function TabPanel(props) {
  const { children, value, index, ...other } = props;
  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && <Box sx={{ p: { xs: 1, lg: 3 } }}>{children}</Box>}
    </div>
  );
}

TabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.any.isRequired,
  value: PropTypes.any.isRequired,
};

export default function Accounts(props) {
  const defaultStartingDate = new Date();
  defaultStartingDate.setMonth(defaultStartingDate.getMonth() - 1); // For subtract use minus (-)

  const transactiUserTypeCode =
    props.transactiUserTypeCode != "" ? props.transactiUserTypeCode : "LSWBAVS";

  const classes = useStyles();
  const [searchAccountTerm, setSearchAccountTerm] = useState({ name: "" });
  const accountsElement = useRef();
  const sellerOrdersElement = useRef();
  const [salesOrders, setSalesOrders] = useState([]);
  const [salesmanVisits, setSalesmanVisits] = useState([]);
  const [salesmanVisitSummary, setSalesmanVisitSummary] = useState([]);
  const [reloadTab, setReloadTab] = useState([]);
  const [autoSuggestAccounts, setAutoSuggestAccounts] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [searchByAnchorElement, setSearchByAnchorElement] =
    React.useState(null);
  const [openDateFilterDialog, setOpenDateFilterDialog] = useState(false);
  const [openStatusFilterDialog, setOpenStatusFilterDialog] = useState(false);
  const [
    openSelectDeliveryPersonelDialog,
    setOpenSelectDeliveryPersonelDialog,
  ] = useState(false);
  const [openSalesManFilterDialog, setOpenSalesManFilterDialog] =
    useState(false);
  const [hasMoreAccountToLoad, setHasMoreAccountToLoad] = useState(true);
  const [pageNumber, setPageNumber] = useState(1);
  const [loadProducts, setLoadProducts] = useState(true);
  const [openStartingDateCalendar, setOpenStartingDateCalendar] =
    useState(false);
  const [startingFilterDate, setStartingFilterDate] = useState(new Date());
  const [endingFilterDate, setEndingFilterDate] = useState(new Date());
  const [endingDate, setEndingDate] = React.useState(new Date());
  const [startingDate, setStartingDate] = React.useState(new Date());
  const [openEndingDateCalendar, setOpenEndingDateCalendar] = useState(false);
  const [selectedStatusFilter, setSelectedStatusFilter] = useState(0);
  const [perOrderTotalUniqueSkuCount, setPerOrderTotalUniqueSkuCount] =
    useState();
  const [totalOrderAmount, setTotalOrderAmount] = useState(0);
  const [totalOrderCount, setTotalOrderCount] = useState(0);
  const [totalUniqueSkuOrderCount, setTotalUniqueSkuOrderCount] = useState(0);
  const [selectedOrder, setSelectedOrder] = useState([]);
  const [orderStatuses, setOrderStatuses] = useState([]);
  const [orderStatusesBreakdown, setOrderStatusesBreakdown] = useState({});
  const [
    selectedOrderToAssignForDelivery,
    setSelectedOrderToAssignForDelivery,
  ] = useState(null);
  const [salesMan, setSalesMan] = useState([]);
  const [selectedSalesMan, setSelectedSalesMan] = useState([]);
  const [selectAllSalesman, setSelectAllSalesman] = useState(true);
  const [menuAnchorEl, setMenuAnchorEl] = useState(null);
  const openMenu = Boolean(menuAnchorEl);
  const [showMessageDialog, setShowMessageDialog] = useState(false);
  const [showCsvMessageDialog, setShowCsvMessageDialog] = useState(false);
  const [csvDownloadPercent, setCsvDownloadPercent] = useState(0);
  const [autoGeneratedSalesOrderIds, setAutoGeneratedSalesOrderIds] = useState(
    []
  );
  const [breakdownProducts, setBreakdownProducts] = useState([]);
  const [openBreakdown, setOpenBreakdown] = useState(false);
  const [openStatusOrderDialog, setOpenStatusOrderDialog] = useState(false);
  const [showProgressDialog, setShowProgressDialog] = useState(false);
  const [orderMenuAnchorElement, setOrderMenuAnchorElement] = useState(null);

  const [showErrorMessageDialog, setShowErrorMessageDialog] = useState(false);
  const [errorMessage, setErrorMessage] = useState(false);

  const [openOrderPickingDialog, setOpenOrderPickingDialog] = useState(false);
  const [selectedSalesOrder, setSelectedSalesOrder] = useState(false);
  const [loadSalesOrderItems, setLoadSalesOrderItems] = useState(false);
  const [salesOrderItems, setSalesOrderItems] = useState([]);
  const [orderstatusSecondSequence, setOrderstatusSecondSequence] =
    useState("Order for Picking");
  const [selectedTab, setSelectedTab] = useState("bookings");

  // VAN ACCOUNT TRANSACTION
  const VanAccountElement = useRef();
  const [vanAccountTransactions, setVanAccountTransactions] = useState([]);
  const [vanOrderSummary, setVanOrderSummary] = useState([]);

  const updateOrderStatusCSVHeader = [
    "Account Name",
    "Account Code",
    "Total Value",
    "P.O Date",
    "P.O Number",
    "Auto Generated ID *",
    "Status *",
  ];

  const forDeliveryAssignmentCSVHeader = [
    "Account Name",
    "Account Name",
    "Account Code",
    "Total Value",
    "P.O Date",
    "P.O Number",
    "Auto Generated ID *",
    "Delivery Personel Username*",
  ];

  const [ordersCSV, setOrdersCSV] = useState([]);
  const [doneDownloadingOrders, setIsDoneDownloadingOrders] = useState(false);

  const [transactionsCSV, setTransactionsCSV] = useState([]);
  const [doneDownloadingTransactions, setIsDoneDownloadingTransactions] =
    useState(false);

  const [csvFile, setCsvFile] = useState("");
  const [showUpdateStatusDialog, setShowUpdateStatusDialog] = useState(false);
  const [showAssignOrderDeliveriesDialog, setShowAssignOrderDeliveriesDialog] =
    useState(false);
  const [downloadOrdersProgress, setDownloadOrdersProgress] = React.useState(0);
  const [isDownloadingOrders, setIsDownloadingOrders] = useState(false);
  const [showUpdateOrderStatusDialog, setShowUpdateOrderStatusDialog] =
    useState(false);

  const [messageDialogMessage, setMessageDialogMessage] = useState("");
  const [autoCompleteSearchOptionMessage, setAutoCompleteSearchOptionMessage] =
    useState("Searching...");
  const [progressDialogMessage, setProgressDialogMessage] = useState("");
  const [updateOrderStatusProgress, setUpdateOrderStatusProgress] = useState(0);
  const [updateStatusErrors, setUpdateStatusErrors] = useState([]);
  const [doneUpdatingStatus, setDoneUpdatingStatus] = useState(false);

  const [uploadCSVErrors, setUploadCSVErrors] = useState([]);
  const [uploadCSVProgress, setUploadCSVProgress] = useState(0);
  const [showUploadCSVDialog, setShowUploadCSVDialog] = useState(false);
  const [uploadCSVDialogTitle, setUploadCSVDialogTitle] = useState("");
  const [isDoneUploadingCSV, setIsDoneUploadingCSV] = useState(false);
  const [selectedDeliveryPersonel, setSelectedDeliveryPersonel] = useState();
  const [assignOrderForDelivery, setAssignOrderForDelivery] = useState(false);

  const [sellerOrderSummary, setSellerOrderSummary] = useState([]);

  // Print via bluetooth
  const [loadingToConnectInBluetooth, setLoadingToConnectInBluetooth] =
    useState(false);
  const [isBluetoothConnected, setIsBluetoothConnected] = useState(false);
  const characteristicRef = useRef(null);

  // PDF OUT
  const [downloadPDF, setDownloadPDF] = useState(false);

  // CANCEL BOOKING ORDER
  const [selectedSalesOrderForCancel, setSelectedSalesOrderForCancel] =
    useState([]);
  const [cancelBookingReason, setCancelBookingReason] = useState("");
  const [showCancelBookingReasonDialog, setShowCancelBookingReasonDialog] =
    useState(false);

  // VAN ACCOUNT ITEMS
  const [selectedVanAccountTransaction, setSelectedVanAccountTransaction] =
    useState([]);
  const [openVanAccountItemsDialog, setOpenVanAccountItemsDialog] =
    useState(false);

  const [tabValue, setTabValue] = useState(0);
  const handleChange = (event, newValue) => {
    setReloadTab(true);
    setTabValue(newValue);
  };

  const lastProductElementObserver = useRef();

  const [isLoadingSalesman, setIsLoadingSalesman] = useState(true);
  const [salesmanPageNumber, setSalesmanPageNumber] = useState(1);
  const [loadSalesMan, setLoadSalesMan] = useState(false);
  const lastSalesmanElementObserver = useRef();
  const lastSalesmanElement = useCallback(
    (node) => {
      if (isLoadingSalesman) {
        return;
      }
      if (lastSalesmanElementObserver.current) {
        lastSalesmanElementObserver.current.disconnect();
      }

      lastSalesmanElementObserver.current = new IntersectionObserver(
        (entries) => {
          if (entries[0].isIntersecting && hasMoreAccountToLoad) {
            lastSalesmanElementObserver.current.disconnect();
            setSalesmanPageNumber((prevPageNumber) => prevPageNumber + 1);
            setLoadSalesMan(true);
          }
        }
      );

      if (node) {
        lastSalesmanElementObserver.current.observe(node);
      }
    },
    [isLoadingSalesman, hasMoreAccountToLoad]
  );

  const [isLoadingFilterSalesman, setIsLoadingFilterSaleman] = useState(true);
  const [hasMoreFilterSalesmanToLoad, setHasMoreFilterSalesmanToLoad] =
    useState(true);
  const lastFilterSalesmanElementObserver = useRef();
  const [loadFilterSalesman, setLoadFilterSalesman] = useState(false);

  const [salesmanFilterPageNumber, setSalesmanFilterPageNumber] = useState(1);
  const lastFilterSalesmanElement = useCallback(
    (node) => {
      if (isLoadingFilterSalesman) {
        return;
      }
      if (lastFilterSalesmanElementObserver.current) {
        lastFilterSalesmanElementObserver.current.disconnect();
      }

      lastFilterSalesmanElementObserver.current = new IntersectionObserver(
        (entries) => {
          if (entries[0].isIntersecting && hasMoreFilterSalesmanToLoad) {
            lastFilterSalesmanElementObserver.current.disconnect();
            setSalesmanFilterPageNumber((prevPageNumber) => prevPageNumber + 1);
            setLoadFilterSalesman(true);
          }
        }
      );

      if (node) {
        lastFilterSalesmanElementObserver.current.observe(node);
      }
    },
    [isLoadingFilterSalesman, hasMoreFilterSalesmanToLoad]
  );

  const [accountsLabel, setAccountLabel] = useState({});
  const [accountClassificationLabel, setAccountClassificationLabel] = useState(
    {}
  );
  const [isLoadingLabel, setIsLoadingLabel] = useState(true);

  useEffect(() => {
    if (!isLoadingLabel) {
      return;
    }

    const getAccountsLabel = () => {
      const options = {
        method: "POST",
        url: "/TransactiLabels/getTransactiLiteLabels.json",
      };

      axios(options)
        .then((res) => {
          const labels = res.data.response;
          const accountLabel = labels.accounts;
          const accountClassificationsLabel = labels.account_classifications;

          setAccountLabel(accountLabel);
          setAccountClassificationLabel(accountClassificationsLabel);
          setIsLoadingLabel(false);
        })
        .catch((error) => {
          console.log(error);
        });
    };

    getAccountsLabel();
  }, [accountsLabel, isLoadingLabel]);

  const searchByBtnHandleClick = (event) => {
    setSearchByAnchorElement(event.currentTarget);
  };

  function autoComplete() {
    return (
      <Autocomplete
        value={searchAccountTerm.name}
        noOptionsText={autoCompleteSearchOptionMessage}
        onChange={(event, newValue) => {
          if (newValue === null || newValue.name === "") {
            setSearchAccountTerm({ name: "" }); // Use the state setter to update the state
            return;
          }
          setSearchAccountTerm({ name: newValue.name });
          setReloadTab(true);
        }}
        clearOnBlur
        selectOnFocus
        handleHomeEndKeys
        options={autoSuggestAccounts}
        isOptionEqualToValue={() => true}
        getOptionLabel={(option) => {
          if (typeof option === "string") {
            return option;
          }
          if (option.inputValue) {
            return option.inputValue;
          }
          if (option.name) {
            return option.name;
          }
          return "";
        }}
        renderOption={(props, option) => {
          return (
            <li {...props} key={option.name + option.id}>
              {option.name}
            </li>
          );
        }}
        style={{ width: "100%", paddingLeft: "8px", outline: "none" }}
        renderInput={(params) => (
          <TextField
            style={{ background: "white" }}
            variant="standard"
            {...params}
            InputProps={{ ...params.InputProps, disableUnderline: true }}
            onChange={(event) => {
              setSearchAccountTerm({ name: event.target.value });
            }}
          />
        )}
      />
    );
  }
  function searchByDropdownMenu() {
    return (
      <Menu
        id="simple-menu"
        anchorEl={searchByAnchorElement}
        keepMounted
        open={Boolean(searchByAnchorElement)}
        onClose={() => {
          setSearchByAnchorElement(null);
        }}
      >
        <MenuItem
          onClick={() => {
            setSearchByAnchorElement(null);
            setOpenDateFilterDialog(true);
          }}
        >
          Select date filter
        </MenuItem>

        {selectedTab === "bookings" && (
          <MenuItem
            onClick={() => {
              setSearchByAnchorElement(null);
              setOpenStatusFilterDialog(true);
            }}
          >
            Select status filter
          </MenuItem>
        )}

        <MenuItem
          onClick={() => {
            setSearchByAnchorElement(null);
            setOpenSalesManFilterDialog(true);
          }}
        >
          Select salesman filter
        </MenuItem>
      </Menu>
    );
  }

  function search() {
    return (
      <div
        position="static"
        style={{
          border: ".1rem solid #989898",
          borderRadius: "4px",
          margin: "2px",
        }}
      >
        <Toolbar variant="dense" style={{ padding: "0" }}>
          <Box flexGrow={1}>{autoComplete()}</Box>
          <Box>
            <IconButton
              className={classes.margin}
              size="large"
              onClick={() => {
                if (selectedTab === "bookings") {
                  setReloadTab(true);
                  fetchAccountOrders(searchAccountTerm.name);
                } else if (selectedTab === "van_orders") {
                  setReloadTab(true);
                  fetchVanAccountTransactions(searchAccountTerm.name);
                } else {
                  setReloadTab(true);
                  fetchSalesmanVisits("");
                }
              }}
            >
              <SearchIcon />
            </IconButton>
          </Box>
          <Box>
            <IconButton
              className={classes.margin}
              size="large"
              onClick={searchByBtnHandleClick}
            >
              <MoreVertIcon />
            </IconButton>
          </Box>
          {searchByDropdownMenu()}
        </Toolbar>
      </div>
    );
  }

  function orderMoreVertDropdownMenu() {
    const status_value = selectedSalesOrder.order_status_value;

    let isDisabledOrderPicking = false;
    let isEnabledForDelivery = false;
    const whenOrderForPicking = ["place order", "pending"];

    const whenToDeliver = ["order for picking", "for delivery"];

    if (selectedSalesOrder.order_status_value) {
      isDisabledOrderPicking = whenOrderForPicking.includes(
        status_value.toLowerCase()
      )
        ? false
        : true;
      isEnabledForDelivery = whenToDeliver.includes(status_value.toLowerCase())
        ? false
        : true;
    }

    return (
      <Menu
        id="simple-menu"
        anchorEl={orderMenuAnchorElement}
        keepMounted
        open={Boolean(orderMenuAnchorElement)}
        onClose={() => {
          setOrderMenuAnchorElement(null);
        }}
      >
        <MenuItem
          disabled={isDisabledOrderPicking}
          onClick={() => {
            setOrderMenuAnchorElement(null);
            setLoadSalesOrderItems(true);
          }}
        >
          Change to {orderstatusSecondSequence}
        </MenuItem>

        <MenuItem
          disabled={isEnabledForDelivery}
          onClick={() => {
            setOrderMenuAnchorElement(null);
            setOpenSelectDeliveryPersonelDialog(true);
          }}
        >
          Assign for delivery
        </MenuItem>
      </Menu>
    );
  }

  useEffect(() => {
    if (!loadSalesOrderItems) {
      return;
    }

    const setSalesOrderForPickingStatus = () => {
      const auto_generated_id = selectedSalesOrder.auto_generated_id;
      setLoadSalesOrderItems(false);
      setIsLoading(true);

      const options = {
        method: "POST",
        url: "/TransactiSellerSalesOrder/setSalesOrderForPickingStatus.json",
        data: objectToFormData({ auto_generated_id: auto_generated_id }),
      };

      axios(options)
        .then((res) => {
          setOpenOrderPickingDialog(true);
          setShowProgressDialog(false);

          const salesOrderItems = res.data.response.SalesOrdersItems;

          fetchAccountOrders("");
          setSalesOrderItems(salesOrderItems);
          const isSuccess = res.data.response.is_success;

          if (!isSuccess) {
            return;
          }
        })
        .catch((error) => {
          setIsLoading(false);
          setShowProgressDialog(false);
          alert("Error encounter");
        });
    };

    setShowProgressDialog(true);
    setProgressDialogMessage("Setting status to for picking. Please wait...");
    setSalesOrderForPickingStatus();
  }, [loadSalesOrderItems]);

  useEffect(() => {
    const fetchSecondOrderOfOrderStatus = () => {
      const options = {
        method: "POST",
        url: "/OrderStatuses/fetchSecondOrderOfOrderStatus.json",
      };

      axios(options)
        .then((res) => {
          const orderStatus = res.data.response.second_sequence_of_status;

          if (orderStatus === null) {
            return;
          }

          const status = orderStatus.value;
          setOrderstatusSecondSequence(status);
        })
        .catch((error) => {
          alert("Error encounter");
        });
    };

    fetchSecondOrderOfOrderStatus();
  }, []);

  useEffect(() => {
    if (transactiUserTypeCode === "LSWVS") {
      setSelectedTab("van_orders");
    } else {
      setSelectedTab("bookings");
    }
  }, [transactiUserTypeCode]);

  function salesOrderElement(salesOrder) {
    return (
      <div style={{ width: "100%" }}>
        <Grid container>
          <Grid container>
            <Grid item xs={12} lg={12}>
              <Box sx={{ marginTop: ".5em" }}>
                <Typography variant="h6">
                  {salesOrder.Account.account_name
                    ? salesOrder.Account.account_name
                    : "NO ACCOUNT NAME"}
                </Typography>
              </Box>

              {salesOrder.Account.street != "" &&
                salesOrder.Account.barangay != "" &&
                salesOrder.Account.street != "" && (
                  <Box sx={{ marginBottom: ".5em" }}>
                    <Typography variant="body" gutterBottom>
                      {salesOrder.Account.street}, {salesOrder.Account.barangay}{" "}
                      {salesOrder.Account.city_municipality}
                    </Typography>
                  </Box>
                )}
            </Grid>
          </Grid>

          <Grid
            item
            xs={salesOrder.invoice_information != null ? 12 : 7}
            lg={7}
          >
            {/* <Grid item xs={salesOrder.booking_status === 0 ? 12 : 7} lg={7}> */}
            <Typography gutterBottom variant="subtitle1">
              Order date: {formatDate(salesOrder.po_datetime)}
              <br />
              Total value:{" "}
              {Number(salesOrder.total_amount).toLocaleString(undefined, {
                minimumFractionDigits: 2,
                maximumFractionDigits: 2,
              })}
              <br />
              Order Status: {renderOrderStatusValue(salesOrder)}
              <br />
              {renderCancelBookingReasons(salesOrder)}
            </Typography>
          </Grid>

          <Grid
            item
            xs={5}
            lg={5}
            sx={{ display: "flex", flexDirection: "column" }}
          >
            {renderActionButtons(salesOrder)}
          </Grid>
        </Grid>
      </div>
    );
  }

  const isLastStep = (index, stepsLength) => {
    return index === stepsLength - 1;
  };

  const getCurrentOrderStatus = (status) => {
    let formattedOrderStatus = status.toLowerCase();
    let activeStep = 1;

    orderStatuses.forEach((status) => {
      let order_status = status.value.toLowerCase();

      // old statuses
      switch (formattedOrderStatus) {
        case "pending":
          formattedOrderStatus = "place order";
          break;
        case "for delivery":
          formattedOrderStatus = "order for delivery";
          break;
      }

      if (order_status === formattedOrderStatus) {
        activeStep = status.sequence - 1;
      }
    });

    return activeStep;
  };

  const renderActionButtons = (salesOrder) => {
    if (
      salesOrder.booking_status === 0 ||
      salesOrder.invoice_information != null
    ) {
      return;
    }

    if (
      salesOrder.booking_status === 1 &&
      salesOrder.invoice_information === null
    ) {
      return (
        <Box
          display="flex"
          flexDirection="column"
          gap={1}
          sx={{
            alignItems: { xs: "flex-start", sm: "center", md: "flex-end" },
            mt: { xs: 1, sm: 0 },
          }}
        >
          <Button
            size="small"
            sx={{
              bgcolor: "red",
              "&:hover": { bgcolor: "darkred" },
              color: "white",
              width: "150px", // Fixed width for consistent button size
            }}
            onClick={(e) => {
              e.stopPropagation();
              setSelectedSalesOrderForCancel(salesOrder);
              setShowCancelBookingReasonDialog(true);
            }}
          >
            Cancel Order
          </Button>
          <Button
            size="small"
            sx={{
              bgcolor: "yellow",
              "&:hover": { bgcolor: "goldenrod" },
              color: "black",
              width: "150px", // Matches the width of the Cancel Order button
            }}
            onClick={(e) => {
              e.stopPropagation();
              itemOnClick(salesOrder);
            }}
          >
            Create Invoice
          </Button>
        </Box>
      );
    }
  };

  const renderCancelBookingReasons = (salesOrder) => {
    if (salesOrder.booking_status === 0 && salesOrder.cancel_reason != "") {
      return (
        <>
          Cancel Order Reason: {salesOrder.cancel_reason}
          <br />
        </>
      );
    }
  };

  const renderOrderStatusValue = (salesOrder) => {
    let status = "";
    if (salesOrder.order_status_value != null) {
      if (
        salesOrder.booking_status === 1 &&
        salesOrder.invoice_information === null &&
        salesOrder.order_status_value == "undefined"
      ) {
        status = "Pending";
      } else if (
        salesOrder.order_status_value !== "" &&
        salesOrder.order_status_value !== "undefined"
      ) {
        status = salesOrder.order_status_value;
      } else {
        status = "Invoiced";
      }
    }

    if (salesOrder.invoice_information != null) {
      status = "Invoiced";
    }

    if (salesOrder.booking_status === 0) {
      status = "Cancelled";
    }

    return status;
  };

  const renderInvoiceButton = (salesOrder) => {
    return (
      <Box
        display="flex"
        sx={{
          justifyContent: { xs: "flex-start", sm: "center", md: "flex-end" },
        }}
      >
        <Button
          size="small"
          autoFocus
          sx={{
            backgroundColor: "yellow",
            "&:hover": { backgroundColor: "yellow" },
            color: "black",
            marginTop: ".5em",
            marginLeft: { xs: ".4em" },
          }}
          onClick={(e) => {
            e.stopPropagation();
            itemOnClick(salesOrder);
            // setSelectedSalesOrder(salesOrder);
          }}
        >
          Create Invoice
        </Button>
      </Box>
    );
  };

  const renderCancelBookingButton = (salesOrder) => {
    return (
      <Box
        display="flex"
        sx={{
          justifyContent: { xs: "flex-start", sm: "center", md: "flex-end" },
        }}
      >
        <Button
          size="small"
          autoFocus
          sx={{
            backgroundColor: "red",
            "&:hover": { backgroundColor: "darkred" },
            color: "white",
            marginTop: { xs: "1em", sm: "0" },
            marginLeft: { lg: "0em", xs: ".6em" },
          }}
          onClick={(e) => {
            e.stopPropagation();
            setSelectedSalesOrderForCancel(salesOrder);
            setShowCancelBookingReasonDialog(true);
          }}
        >
          Cancel Order
        </Button>
      </Box>
    );
  };

  useEffect(() => {
    if (!selectedSalesOrder) {
      return;
    }
  }, [selectedSalesOrder]);

  const renderOrderForPickingButtons = (showOrderForPickingBtn, salesOrder) => {
    if (showOrderForPickingBtn) {
      return (
        <>
          <br />
          <Button
            size="small"
            autoFocus
            color="success"
            className={classes.printBtn}
            startIcon={<PrintIcon />}
            onClick={(e) => {
              e.stopPropagation();
              handleFetchSalesOrderProducts("bluetooth", salesOrder);
              setSelectedSalesOrder(salesOrder);
            }}
          >
            Print Via bluetooth
          </Button>
          <br />
          <Button
            size="small"
            autoFocus
            color="success"
            className={classes.printBtn}
            startIcon={<PictureAsPdfIcon />}
            onClick={(e) => {
              e.stopPropagation();
              handleFetchSalesOrderProducts("pdf", salesOrder);
              setSelectedSalesOrder(salesOrder);
            }}
          >
            Download AS PDF
          </Button>
        </>
      );
    }
  };

  useEffect(() => {
    if (!downloadPDF || !salesOrderItems) {
      return;
    }

    generatePDF();
  }, [downloadPDF, salesOrderItems]);

  const generatePDF = async () => {
    if (!selectedSalesOrder || salesOrderItems.length === 0) {
      return;
    }

    try {
      const doc = new jsPDF();
      const po_number = selectedSalesOrder.po_number;
      const date = new Date(selectedSalesOrder.po_datetime);
      const options = { year: "numeric", month: "long", day: "numeric" };
      const formatted_po_datetime = date.toLocaleDateString("en-US", options);
      const account_info =
        selectedSalesOrder.account_name +
        " (" +
        selectedSalesOrder.account_code +
        ")";
      const order_status_value =
        selectedSalesOrder.order_status_value === "Place Order"
          ? "Order for Picking"
          : selectedSalesOrder.order_status_value;
      const salesman_name =
        selectedSalesOrder.salesman_first_name +
        " " +
        selectedSalesOrder.salesman_middle_name +
        " " +
        selectedSalesOrder.salesman_last_name;

      const total_amount = Number(
        selectedSalesOrder.total_amount
      ).toLocaleString(undefined, {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
      });

      const lineHeight = 1.2;
      const labelSpacing = 5;

      const startX = 14;
      const startY = 22;

      let currentX = startX;
      let currentY = startY;

      doc.setFontSize(12);

      const title = "Ordered Items for Picking";

      const pageWidth = doc.internal.pageSize.getWidth();
      const pageHeight = doc.internal.pageSize.getHeight();
      const textWidth = doc.getTextDimensions(title).w;
      const textHeight = doc.getTextDimensions(title).h;

      const x = (pageWidth - textWidth) / 2;
      const y = 8;

      doc.setFont("helvetica", "bold");
      doc.text(title, x, y);

      const account_info_label = "ACCOUNT NAME :";
      doc.text(account_info_label, currentX, currentY);

      const accountInfoLabelWidth = doc.getTextDimensions(account_info_label).w;
      const accountInfoValueX = currentX + accountInfoLabelWidth + labelSpacing;
      doc.setFont("helvetica", "normal");
      doc.text(account_info, accountInfoValueX, currentY);

      // Move to the next line
      currentY += doc.getTextDimensions(account_info_label).h * lineHeight;

      // PO NUMMBER
      doc.setFont("helvetica", "bold");
      const po_number_label = "P.O NUMBER :";
      doc.text(po_number_label, currentX, currentY);

      const poNumberLabelWidth = doc.getTextDimensions(po_number_label).w;
      const poNumberValueX = currentX + poNumberLabelWidth + labelSpacing;

      doc.setFont("helvetica", "normal");
      doc.text(po_number, poNumberValueX, currentY);

      // Move to the next line
      currentY += doc.getTextDimensions(po_number_label).h * lineHeight;

      // PO DATE
      doc.setFont("helvetica", "bold");
      const po_date_label = "P.O DATE :";
      doc.text(po_date_label, currentX, currentY);

      const poDateLabelWidth = doc.getTextDimensions(account_info_label).w;
      const poDateLabelValueX = poDateLabelWidth + labelSpacing;
      doc.setFont("helvetica", "normal");
      doc.text(formatted_po_datetime, poDateLabelValueX, currentY);

      // Move to the next line
      currentY += doc.getTextDimensions(po_date_label).h * lineHeight;

      // SALESMAN NAME
      doc.setFont("helvetica", "bold");
      const salesman_label = "SALESMAN :";
      doc.text(salesman_label, currentX, currentY);

      const salesmanLabelWidth = doc.getTextDimensions(salesman_label).w;
      const salesmanLabelValueX = currentX + salesmanLabelWidth + labelSpacing;
      doc.setFont("helvetica", "normal");
      doc.text(salesman_name, salesmanLabelValueX, currentY);

      // Move to the next line
      currentY += doc.getTextDimensions(salesman_label).h * lineHeight;

      // SALESMAN NAME
      doc.setFont("helvetica", "bold");
      const order_status_label = "ORDER STATUS :";
      doc.text(order_status_label, currentX, currentY);

      const orderStatusWidth = doc.getTextDimensions(order_status_label).w;
      const orderStatusValueX = currentX + orderStatusWidth + labelSpacing;
      doc.setFont("helvetica", "normal");
      doc.text(order_status_value, orderStatusValueX, currentY);

      // Move to the next line
      currentY += doc.getTextDimensions(salesman_label).h * 3;

      doc.setFont("helvetica", "bold");
      const ordered_items_label = "ORDERED ITEMS";
      doc.text(ordered_items_label, currentX, currentY);

      // Move to the next line
      currentY += doc.getTextDimensions(salesman_label).h * 2;

      const columns = [
        "Product Name",
        "Product Code",
        "UOM",
        "Quantity",
        "Price",
      ];
      const rows = salesOrderItems.map((item) => [
        item.product_name,
        item.product_code,
        item.uom,
        item.order_quantity,
        Number(item.price_with_tax).toLocaleString(undefined, {
          minimumFractionDigits: 2,
          maximumFractionDigits: 2,
        }),
      ]);

      // Add the table
      doc.autoTable({
        startY: currentY,
        head: [columns],
        body: rows,
        theme: "grid",
        headStyles: {
          fillColor: [255, 255, 255],
          textColor: [0, 0, 0],
          lineWidth: 0.5,
          lineColor: [0, 0, 0],
        },
        styles: {
          fillColor: [255, 255, 255],
          textColor: [0, 0, 0],
          lineWidth: 0.5,
          lineColor: [0, 0, 0],
        },
      });

      const finalY = doc.lastAutoTable.finalY;
      doc.text(`Grand Total Amount: ${total_amount}`, 14, finalY + 10);

      // Save the PDF
      doc.save("Account Orders.pdf");
      setDownloadPDF(false);
    } catch (error) {
      console.log(error);
    }
  };

  const formatNumberToTwoDigit = (number) => {
    const formattedNumber = new Intl.NumberFormat("en-US", {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    }).format(number);

    return formattedNumber;
  };

  const handleFetchSalesOrderProducts = async (type, salesOrder) => {
    const auto_generated_id = salesOrder.auto_generated_id;

    const options = {
      method: "POST",
      url: "/TransactiSellerSalesOrder/findSalesOrderItemsByAutoGeneratedId.json",
      data: objectToFormData({ auto_generated_id: auto_generated_id }),
    };

    setShowProgressDialog(true);
    setProgressDialogMessage("Fetching Orders... Please wait...");

    await axios(options)
      .then((res) => {
        const salesOrderItems = res.data.response.SalesOrdersItems;
        const isSuccess = res.data.response.is_success;

        if (!isSuccess) {
          alert("Failed to fetch sales order items.");
          return;
        }

        setIsLoading(false);
        setShowProgressDialog(false);
        setSalesOrderItems(salesOrderItems);

        if (type === "bluetooth") {
          handleConnectToBluetooth();
        } else {
          setDownloadPDF(true);
        }
      })
      .catch((error) => {
        setIsLoading(false);
        setShowProgressDialog(false);

        setShowMessageDialog(true);
        setMessageDialogMessage(error);
      });
  };

  const handleConnectToBluetooth = async () => {
    try {
      setShowProgressDialog(true);
      setProgressDialogMessage("Searching for your device... Please wait...");

      const available = await navigator.bluetooth.getAvailability();

      if (!available) {
        setShowProgressDialog(false);
        alert("Bluetooth is not available on this device.");
        return;
      }

      const device = await navigator.bluetooth.requestDevice({
        filters: [{ services: ["000018f0-0000-1000-8000-00805f9b34fb"] }],
      });

      setProgressDialogMessage("Connecting to device...");
      const server = await device.gatt.connect();

      setProgressDialogMessage("Getting primary service...");
      const service = await server.getPrimaryService(
        "000018f0-0000-1000-8000-00805f9b34fb"
      );

      setProgressDialogMessage("Getting characteristic...");
      const characteristic = await service.getCharacteristic(
        "00002af1-0000-1000-8000-00805f9b34fb"
      );

      characteristicRef.current = characteristic;

      setIsBluetoothConnected(true);
    } catch (error) {
      console.error("Error connecting to Bluetooth:", error);
      setShowProgressDialog(false);
      alert("An error occurred while trying to connect to Bluetooth.");
    }
  };

  useEffect(() => {
    if (!isBluetoothConnected || !selectedSalesOrder) {
      return;
    }

    const handlePrintViaBluetooth = async () => {
      try {
        setProgressDialogMessage("Printing Orders... Please wait...");

        await printAccountInformation();
        await delay(1000);
        await printItems();
        await delay(1000);
      } catch (error) {
        setShowMessageDialog(true);
        setMessageDialogMessage(error);
        setShowProgressDialog(false);
      } finally {
        setShowMessageDialog(true);
        setMessageDialogMessage("Done Printing");

        setIsBluetoothConnected(false);
        setShowProgressDialog(false);
      }
    };

    handlePrintViaBluetooth();
  }, [isBluetoothConnected, selectedSalesOrder]);

  /**
   * Print Bluetooth Account Info
   */
  const printAccountInformation = async () => {
    const characteristic = characteristicRef.current;

    if (!characteristic) {
      console.error("Characteristic is not defined");
      return;
    }

    const resetAlignment = new Uint8Array([0x1b, 0x61, 0x00]); // ESC a 0x00 - reset alignment
    const salesOrder = selectedSalesOrder;

    // P.O Number
    const po_number_text = `P.O Number: ${salesOrder.po_number}\r\n`;
    const encoded_po_number_text = new TextEncoder().encode(po_number_text);
    await characteristic.writeValue(encoded_po_number_text);
    const po_number_command = new Uint8Array([0x1b, 0x61, 0x02]); // ESC a 0x02 - right alignment
    await characteristic.writeValue(po_number_command);
    await characteristic.writeValue(resetAlignment);

    // P.O Date
    const date = new Date(salesOrder.po_datetime);
    const options = { year: "numeric", month: "long", day: "numeric" };
    const formattedDate = date.toLocaleDateString("en-US", options);

    const po_date_text = `P.O Date: ${formattedDate}\r\n`;
    const encoded_po_date_text = new TextEncoder().encode(po_date_text);
    await characteristic.writeValue(encoded_po_date_text);
    const po_date_command = new Uint8Array([0x1b, 0x61, 0x02]); // ESC a 0x02 - right alignment
    await characteristic.writeValue(po_date_command);
    await characteristic.writeValue(resetAlignment);

    // Total Value
    const total_value_text = `Total Value: ${salesOrder.total_amount}\r\n`;
    const encoded_total_value_text = new TextEncoder().encode(total_value_text);
    await characteristic.writeValue(encoded_total_value_text);
    const total_value_command = new Uint8Array([0x1b, 0x61, 0x02]); // ESC a 0x02 - right alignment
    await characteristic.writeValue(total_value_command);
    await characteristic.writeValue(resetAlignment);

    // Salesman Name
    const sales_man_name = `${salesOrder.salesman_first_name} ${salesOrder.salesman_middle_name} ${salesOrder.salesman_last_name}`;
    const sales_man_name_text = `Salesman Name: ${sales_man_name}\r\n`;
    const encoded_sales_man_name_text = new TextEncoder().encode(
      sales_man_name_text
    );
    await characteristic.writeValue(encoded_sales_man_name_text);
    const sales_man_name_command = new Uint8Array([0x1b, 0x61, 0x02]); // ESC a 0x02 - right alignment
    await characteristic.writeValue(sales_man_name_command);
    await characteristic.writeValue(resetAlignment);

    // Order Status
    const order_status_text = `Order Status: ${salesOrder.order_status_value}\r\n`;
    const encoded_order_status_text = new TextEncoder().encode(
      order_status_text
    );
    await characteristic.writeValue(encoded_order_status_text);
    const order_status_command = new Uint8Array([0x1b, 0x61, 0x02]); // ESC a 0x02 - right alignment
    await characteristic.writeValue(order_status_command);
    await characteristic.writeValue(resetAlignment);

    const divider = "********************************\r\n";
    const divideData = new TextEncoder().encode(divider);
    await characteristic.writeValue(divideData);
    const centerCommand = new Uint8Array([0x1b, 0x61, 0x01]); // ESC a 0x01 - center alignment
    await characteristic.writeValue(centerCommand);
  };

  const printItems = async () => {
    const characteristic = characteristicRef.current;

    if (!characteristic) {
      console.error("Characteristic is not defined");
      return;
    }

    if (salesOrderItems.length === 0) {
      return;
    }

    // Write a command to the printer to reset the text alignment
    const resetAlignment = new Uint8Array([0x1b, 0x61, 0x00]); // ESC a 0x00 - reset alignment

    // Spaces
    const spaces = "\r\n";
    const spaces_data = new TextEncoder().encode(spaces);
    await characteristic.writeValue(spaces_data);
    const command4 = new Uint8Array([0x1b, 0x61, 0x02]); // ESC a 0x02 - right alignment
    await characteristic.writeValue(command4);
    await characteristic.writeValue(resetAlignment);

    for (const items of salesOrderItems) {
      await printProductElements(items);
    }

    await characteristic.writeValue(spaces_data); // ESC a 0x02 - right alignment
    await characteristic.writeValue(command4);
    await characteristic.writeValue(resetAlignment);

    const divider = "********************************\r\n";
    const divideData = new TextEncoder().encode(divider);
    await characteristic.writeValue(divideData);
    const centerCommand = new Uint8Array([0x1b, 0x61, 0x01]); // ESC a 0x01 - center alignment
    await characteristic.writeValue(centerCommand);

    const computedAmount = computeTotalSalesOrderAmount();
    const total = "Total : " + computedAmount + "\r\n";
    const total_data = new TextEncoder().encode(total);
    await characteristic.writeValue(resetAlignment);
    await characteristic.writeValue(total_data);
    const command5 = new Uint8Array([0x1b, 0x61, 0x02]); // ESC a 0x02 - right alignment
    await characteristic.writeValue(command5);
    await characteristic.writeValue(resetAlignment);
  };

  const printProductElements = async (product) => {
    const characteristic = characteristicRef.current;

    // Write a command to the printer to reset the text alignment
    const resetAlignment = new Uint8Array([0x1b, 0x61, 0x00]); // ESC a 0x00 - reset alignment

    const product_name =
      product.product_name !== undefined
        ? product.product_name + "\r\n"
        : "NO PRODUCT NAME\r\n";
    const product_name_data = new TextEncoder().encode(product_name);
    await characteristic.writeValue(resetAlignment);
    await characteristic.writeValue(product_name_data);
    const command2 = new Uint8Array([0x1b, 0x61, 0x02]); // ESC a 0x02 - right alignment
    await characteristic.writeValue(command2);
    await characteristic.writeValue(resetAlignment);

    await delay(1000);

    const computation =
      product.price_with_tax +
      " x " +
      product.order_quantity +
      " " +
      product.uom +
      " = " +
      Number(
        (product.price_with_tax * product.order_quantity).toFixed(2)
      ).toLocaleString("en-US", {
        maximumFractionDigits: 2,
      }) +
      "\r\n";
    const computation_data = new TextEncoder().encode(computation);
    await characteristic.writeValue(computation_data);
    const command3 = new Uint8Array([0x1b, 0x61, 0x02]); // ESC a 0x02 - right alignment
    await characteristic.writeValue(command3);
    await characteristic.writeValue(resetAlignment);
  };

  const delay = (ms) => {
    return new Promise((resolve) => setTimeout(resolve, ms));
  };

  const computeTotalSalesOrderAmount = () => {
    const totalInvoicedValue = Number(
      salesOrderItems.reduce((partialSum, product) => {
        // Parse price_with_tax to a floating-point number
        const priceWithTax = parseFloat(product.price_with_tax);

        // Check if the parsed value is a valid number
        if (isNaN(priceWithTax)) {
          console.error("Invalid price_with_tax:", product.price_with_tax);
          return partialSum; // Ignore invalid value and return current partial sum
        }

        // Parse quantity_invoiced to a floating-point number
        const quantityInvoiced = parseFloat(product.order_quantity);

        // Calculate the partial sum for the current product
        const productTotal = priceWithTax * quantityInvoiced;

        return partialSum + productTotal;
      }, 0)
    );

    return totalInvoicedValue;
  };

  useEffect(() => {
    getTransactiOrderStatuses();
    getTransactiSellerSalesMan();
  }, []);

  const getTransactiOrderStatuses = () => {
    const options = {
      method: "POST",
      url: "/OrderStatuses/getTransactiOrderStatuses.json",
    };

    axios(options)
      .then((res) => {
        const order_statuses = res.data.orderStatuses;
        setOrderStatuses(order_statuses);
      })
      .catch((err) => {
        console.log(err);
      });
  };

  useEffect(() => {
    if (!loadFilterSalesman) {
      return;
    }
    getTransactiSellerSalesMan();
  }, [loadFilterSalesman, hasMoreFilterSalesmanToLoad]);

  const getTransactiSellerSalesMan = () => {
    const options = {
      method: "POST",
      url: "/TransactiSalesman/getTransactiSellerSalesman.json",
      data: objectToFormData({
        page_number: salesmanFilterPageNumber,
      }),
    };

    axios(options)
      .then((res) => {
        setLoadFilterSalesman(false);
        setIsLoadingFilterSaleman(false);
        const seller_sales_man = res.data.response.Salesmans;
        setHasMoreFilterSalesmanToLoad(seller_sales_man.length > 0);
        setSalesMan(salesMan.concat(seller_sales_man));
      })
      .catch((err) => {
        setLoadFilterSalesman(false);
        console.log(err);
      });
  };

  const handleClickGetOrderStatus = (salesOrder, event) => {
    event.preventDefault();
    event.stopPropagation();

    setSelectedOrder(salesOrder);
    setOpenStatusOrderDialog(true);
  };

  const orderStatusDialog = () => {
    return (
      <Dialog
        fullWidth={true}
        open={openStatusOrderDialog}
        onClose={() => setOpenStatusOrderDialog(false)}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle id="alert-dialog-title">
          {"Transacti Order Statuses"}
        </DialogTitle>
        <DialogContent>
          <Grid container spacing={1}>
            <Grid item xs={12}>
              <List>
                {orderStatuses.length === 0 ? (
                  <Typography variant="body1" color="textSecondary">
                    No order status to display.
                  </Typography>
                ) : (
                  orderStatuses.map((orderStatus, index) => (
                    <ListItemButton
                      divider
                      key={index}
                      onClick={() => {
                        handleUpdateOrderStatus(orderStatus);
                        setOpenStatusOrderDialog(false);
                      }}
                    >
                      {orderStatus.value}
                    </ListItemButton>
                  ))
                )}
              </List>
            </Grid>
          </Grid>
        </DialogContent>
        <DialogActions>
          <Button
            onClick={() => setOpenStatusOrderDialog(false)}
            color="primary"
            autoFocus
          >
            Close
          </Button>
        </DialogActions>
      </Dialog>
    );
  };

  const handleUpdateOrderStatus = (orderStatus) => {
    const auto_generated_id = selectedOrder.auto_generated_id;
    const order_status = orderStatus.value;

    setShowProgressDialog(true);
    setProgressDialogMessage("Updating order status... Please wait...");

    const options = {
      method: "POST",
      url: "/OrderStatuses/updateSalesOrderOrderStatus.json",
      data: objectToFormData({
        auto_generated_id: auto_generated_id,
        order_status: order_status,
      }),
    };

    axios(options)
      .then((res) => {
        setShowProgressDialog(false);

        const isSuccess = res.data.response.is_success;
        const message = res.data.response.message;

        setShowMessageDialog(true);
        setMessageDialogMessage(message);
        fetchAccountOrders("");
      })
      .catch((err) => {
        setShowProgressDialog(false);
        setShowMessageDialog(true);
        setMessageDialogMessage(err);
      });
  };

  const progressDialog = () => {
    return (
      <Dialog
        fullWidth={true}
        maxWidth={"lg"}
        open={showProgressDialog}
        onClose={() => {}}
      >
        <DialogContent>
          <DialogContentText>{progressDialogMessage}</DialogContentText>
          <LinearProgress color="secondary" />
        </DialogContent>
      </Dialog>
    );
  };

  function dateRangeFilterDialog() {
    return (
      <Dialog
        fullWidth={true}
        open={openDateFilterDialog}
        onClose={() => {}}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle id="alert-dialog-title">{"Filter date"}</DialogTitle>
        <DialogContent>
          <Grid container spacing={1}>
            {/* Starting Date Picker */}
            <Grid item xs={12}>
              <StyledEngineProvider injectFirst>
                <ThemeProvider theme={materialTheme}>
                  <LocalizationProvider dateAdapter={AdapterDateFns}>
                    <MobileDatePicker
                      inputFormat="MMMM d, yyyy"
                      value={startingDate}
                      open={openStartingDateCalendar}
                      onChange={(date) => {
                        if (date) setStartingDate(date);
                      }}
                      onOpen={() => setOpenStartingDateCalendar(true)}
                      onClose={() => setOpenStartingDateCalendar(false)}
                      renderInput={(params) => (
                        <TextField
                          {...params}
                          label={"Starting Date"}
                          style={{ width: "99%", margin: "1%" }}
                          InputProps={{
                            endAdornment: (
                              <InputAdornment position="end">
                                <IconButton
                                  edge="end"
                                  onClick={() =>
                                    setOpenStartingDateCalendar(true)
                                  }
                                >
                                  <EventIcon />
                                </IconButton>
                              </InputAdornment>
                            ),
                          }}
                        />
                      )}
                    />
                  </LocalizationProvider>
                </ThemeProvider>
              </StyledEngineProvider>
            </Grid>

            {/* Ending Date Picker */}
            <Grid item xs={12}>
              <StyledEngineProvider injectFirst>
                <ThemeProvider theme={materialTheme}>
                  <LocalizationProvider dateAdapter={AdapterDateFns}>
                    <MobileDatePicker
                      inputFormat="MMMM d, yyyy"
                      value={endingDate}
                      open={openEndingDateCalendar}
                      minDate={startingDate} // Prevent selecting past start date
                      onChange={(date) => {
                        if (date) setEndingDate(date);
                      }}
                      onOpen={() => setOpenEndingDateCalendar(true)}
                      onClose={() => setOpenEndingDateCalendar(false)}
                      renderInput={(params) => (
                        <TextField
                          {...params}
                          label={"Ending Date"}
                          style={{ width: "99%", margin: "1%" }}
                          InputProps={{
                            endAdornment: (
                              <InputAdornment position="end">
                                <IconButton
                                  edge="end"
                                  onClick={() =>
                                    setOpenEndingDateCalendar(true)
                                  }
                                >
                                  <EventIcon />
                                </IconButton>
                              </InputAdornment>
                            ),
                          }}
                        />
                      )}
                    />
                  </LocalizationProvider>
                </ThemeProvider>
              </StyledEngineProvider>
            </Grid>
          </Grid>
        </DialogContent>
        <DialogActions>
          <Button
            onClick={() => {
              if (!startingDate || !endingDate) {
                setShowErrorMessageDialog(true);
                setErrorMessage("Please select valid dates.");
                return;
              }

              if (new Date(startingDate) <= new Date(endingDate)) {
                setOpenDateFilterDialog(false);
                setStartingFilterDate(startingDate);
                setEndingFilterDate(endingDate);
                setReloadTab(true);
                setSalesmanVisits([]);
                setSalesmanPageNumber(1);
              } else {
                setShowErrorMessageDialog(true);
                setErrorMessage(
                  "Invalid date range. End date must not be earlier than start date."
                );
              }
            }}
            color="primary"
            autoFocus
          >
            Continue
          </Button>
        </DialogActions>
      </Dialog>
    );
  }

  function statusFilterDialog() {
    return (
      <Dialog
        fullWidth={true}
        open={openStatusFilterDialog}
        onClose={() => {}}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle id="alert-dialog-title">Status Filter</DialogTitle>
        <DialogContent>
          <FormControl
            onChange={(event) => {
              setSelectedStatusFilter(event.target.value);
              setOpenStatusFilterDialog(false);
              setReloadTab(true);
            }}
          >
            <RadioGroup
              defaultValue={selectedStatusFilter}
              name="filter-option"
            >
              <FormControlLabel
                value="0"
                control={<Radio />}
                label="Pending orders"
              />
              <FormControlLabel
                value="1"
                control={<Radio />}
                label="Invoiced orders"
              />
              <FormControlLabel
                value="2"
                control={<Radio />}
                label="All orders"
              />
            </RadioGroup>
          </FormControl>
        </DialogContent>
        <DialogActions>
          <Button
            onClick={() => {
              setOpenStatusFilterDialog(false);
            }}
            color="primary"
            autoFocus
          >
            Close
          </Button>
        </DialogActions>
      </Dialog>
    );
  }

  function selectDeliveryPersonelDialog() {
    return (
      <Dialog
        fullWidth={true}
        open={openSelectDeliveryPersonelDialog}
        onClose={() => {}}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle id="alert-dialog-title">
          Select Delivery Personnel
        </DialogTitle>
        <DialogContent>
          <FormControl>
            <RadioGroup
              onChange={(event) => {
                setSelectedDeliveryPersonel(event.target.value);
              }}
              name="filter-option"
            >
              {salesMan.map((user, index) => (
                <FormControlLabel
                  ref={
                    salesMan.length === index + 1
                      ? lastFilterSalesmanElement
                      : null
                  }
                  key={user.username}
                  value={user.username}
                  control={<Radio />}
                  label={`${user.full_name} (${user.username})`}
                />
              ))}
            </RadioGroup>
          </FormControl>
        </DialogContent>
        <DialogActions>
          <Button
            onClick={() => {
              setOpenSelectDeliveryPersonelDialog(false);
              setAssignOrderForDelivery(true);
            }}
            color="primary"
            autoFocus
          >
            Assign
          </Button>
          <Button
            onClick={() => {
              setOpenSelectDeliveryPersonelDialog(false);
            }}
            color="primary"
            autoFocus
          >
            Cancel
          </Button>
        </DialogActions>
      </Dialog>
    );
  }

  const orderForPickingDialog = () => {
    return (
      <Dialog
        fullWidth={true}
        open={openOrderPickingDialog}
        onClose={() => {}}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle id="alert-dialog-title">Order for picking</DialogTitle>

        <DialogContent>{renderOrderForPickingContent()}</DialogContent>

        <DialogActions>
          <Button
            onClick={() => {
              setOpenOrderPickingDialog(false);
              handleConnectToBluetooth();
            }}
            color="primary"
            autoFocus
          >
            Print via bluetooth
          </Button>

          <Button
            onClick={() => {
              setOpenOrderPickingDialog(false);
              setDownloadPDF(true);
            }}
            color="primary"
            autoFocus
          >
            Download PDF
          </Button>

          <Button
            onClick={() => {
              setOpenOrderPickingDialog(false);
            }}
            color="primary"
            autoFocus
          >
            Cancel
          </Button>
        </DialogActions>
      </Dialog>
    );
  };

  const renderOrderForPickingContent = () => {
    if (salesOrderItems.length === 0) {
      return;
    }

    const total_amount = computePriceWithTax(salesOrderItems);

    return (
      <>
        <List>
          {salesOrderItems.map((item, index) => (
            <>
              <List component="div" disablePadding>
                <ListItem key={index} button>
                  <ListItemText
                    primary={
                      <React.Fragment>
                        <Typography
                          variant="body2"
                          color="textPrimary"
                          sx={{ fontWeight: "bold" }}
                        >
                          {item.product_name} {`(${item.product_code})`}
                        </Typography>
                        <Typography variant="body2" color="textPrimary">
                          Order Quantity:{" "}
                          <span style={{ color: "green" }}>
                            {Number(item.order_quantity).toLocaleString()}
                          </span>
                        </Typography>
                        <Typography variant="body2" color="textPrimary">
                          Amount:{" "}
                          <span style={{ color: "green" }}>
                            ₱
                            {Number(item.price_with_tax).toLocaleString(
                              undefined,
                              {
                                minimumFractionDigits: 2,
                                maximumFractionDigits: 2,
                              }
                            )}
                          </span>
                        </Typography>
                      </React.Fragment>
                    }
                  />
                  <Divider />
                </ListItem>
              </List>
            </>
          ))}

          <Typography
            variant="body1"
            color="textPrimary"
            sx={{ padding: "20px", fontWeight: "bold" }}
          >
            Total Sales:{" "}
            <span style={{ color: "green", fontWeight: "bold" }}>
              ₱
              {Number(total_amount).toLocaleString(undefined, {
                minimumFractionDigits: 2,
                maximumFractionDigits: 2,
              })}
            </span>
          </Typography>
        </List>
      </>
    );
  };

  const computePriceWithTax = (salesOrderItems) => {
    return salesOrderItems.reduce((total, item) => {
      return total + item.price_with_tax;
    }, 0);
  };
  const salesManFilterDialog = () => {
    return (
      <Dialog
        fullWidth={true}
        open={openSalesManFilterDialog}
        onClose={() => setOpenSalesManFilterDialog(false)}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle id="alert-dialog-title">{"Select Salesman"}</DialogTitle>
        <DialogContent>
          <Grid container spacing={1}>
            <Grid item xs={12}>
              <List>
                {salesMan.length === 0 ? (
                  <Typography variant="body1" color="textSecondary">
                    No Salesman to display.
                  </Typography>
                ) : (
                  <>
                    <ListItemButton divider onClick={handleAllSalesmanChange}>
                      <Checkbox checked={selectAllSalesman} />
                      All
                    </ListItemButton>
                    {salesMan.map((user, index) => (
                      <ListItemButton
                        ref={
                          salesMan.length === index + 1
                            ? lastFilterSalesmanElement
                            : null
                        }
                        divider
                        key={index}
                        onClick={() =>
                          handleSelectSalesManChange(user.username)
                        }
                      >
                        <Checkbox
                          checked={selectedSalesMan.includes(user.username)}
                        />
                        {user.full_name} ({user.username})
                      </ListItemButton>
                    ))}
                  </>
                )}
              </List>
            </Grid>
          </Grid>
        </DialogContent>
        <DialogActions>
          <Button
            onClick={() => {
              handleFilterOrdersByUsername();
              setReloadTab(true);
            }}
            color="primary"
            autoFocus
          >
            Continue
          </Button>
        </DialogActions>
      </Dialog>
    );
  };

  const handleSelectSalesManChange = (user) => {
    if (selectedSalesMan.includes(user)) {
      setSelectedSalesMan(
        selectedSalesMan.filter((selectedSalesMan) => selectedSalesMan !== user)
      );
    } else {
      setSelectedSalesMan([...selectedSalesMan, user]);
    }

    if (salesMan.length === selectedSalesMan.length) {
      setSelectAllSalesman(true);
    } else {
      setSelectAllSalesman(false);
    }
  };
  useEffect(() => {
    if (salesMan.length === selectedSalesMan.length) {
      setSelectAllSalesman(true);
    } else {
      setSelectAllSalesman(false);
    }
  }, [selectAllSalesman, selectedSalesMan]);
  const handleAllSalesmanChange = () => {
    setSelectAllSalesman(!selectAllSalesman);
    setSelectedSalesMan(
      selectAllSalesman ? [] : salesMan.map((user) => user.username)
    );
  };
  const handleFilterOrdersByUsername = () => {
    setOpenSalesManFilterDialog(false);
    setSalesmanVisits([]);
    setSalesmanPageNumber(1);
    setReloadTab(true);
  };
  const itemOnClick = (salesOrder) => {
    if (salesOrder.invoice_information != null) {
      setShowMessageDialog(true);
      setMessageDialogMessage("Items already invoiced.");
      return;
    }

    props.openDialogInputHandleClick(salesOrder);
  };
  function formatDate(dateString) {
    try {
      return format(parseISO(dateString), "MMM d, yyyy");
    } catch (err) {
      return "";
    }
  }

  useEffect(() => {
    if (!reloadTab) {
      return;
    }

    const fetchData = async () => {
      try {
        let search = "";
        if (searchAccountTerm.name !== "") {
          search = searchAccountTerm.name;
        }

        if (transactiUserTypeCode === "LSWBS") {
          switch (tabValue) {
            case 0:
              await fetchAccountOrders(search);
              break;
            case 1:
              await fetchSalesmanVisits("");
              break;
          }

          return;
        }

        if (transactiUserTypeCode === "LSWVS") {
          switch (tabValue) {
            case 0:
              await fetchVanAccountTransactions(search);
              break;
            case 1:
              await fetchSalesmanVisits("");
              break;
          }

          return;
        }

        if (transactiUserTypeCode === "LSWBAVS") {
          switch (tabValue) {
            case 0:
              await fetchAccountOrders(search);
              break;
            case 1:
              await fetchVanAccountTransactions(search);
              break;
            case 2:
              await fetchSalesmanVisits("");
              break;
          }

          return;
        }
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    };

    fetchData();
    setReloadTab(false);
  }, [reloadTab]);

  useEffect(() => {
    fetchAccountForAutoSuggest(searchAccountTerm.name);
  }, [searchAccountTerm]);

  function fetchAccountForAutoSuggest(searchTerm) {
    setAutoCompleteSearchOptionMessage("Searching...");
    const options = {
      method: "POST",
      url: "/SellerAccounts/getSellerAccountsForAutoSuggest.json",
      data: objectToFormData({ search_term: searchTerm }),
    };
    axios(options)
      .then((res) => {
        const isSuccess = res.data.response.is_success;

        if (!isSuccess) {
          alert("Error encounter");
          return;
        }
        const suggestedAccounts = res.data.response.seller_accounts;
        if (suggestedAccounts.length <= 0) {
          setAutoCompleteSearchOptionMessage("No record found");
        }

        setAutoSuggestAccounts(suggestedAccounts);
      })
      .catch((error) => {
        alert("Error encounter");
      });
  }
  function fetchAccountOrders(searchTerm) {
    setIsLoading(true);
    const options = {
      method: "POST",
      url: "/TransactiSellerSalesOrder/getTransactiSellerOrder.json",
      data: objectToFormData({
        search_term: searchTerm,
        status_filter: selectedStatusFilter,
        start_date: format(startingFilterDate, "yyyy-MM-dd"),
        end_date: format(endingFilterDate, "yyyy-MM-dd"),
        selectedSalesMan: selectedSalesMan,
      }),
    };
    axios(options)
      .then((res) => {
        setIsLoading(false);
        const isSuccess = res.data.response.is_success;

        if (!isSuccess) {
          alert("Error encounter");
          return;
        }

        setSalesOrders(res.data.response.SalesOrders);

        setSellerOrderSummary(res.data.response);

        setPerOrderTotalUniqueSkuCount(
          res.data.response.per_order_total_unique_sku_count
        );
        setTotalOrderAmount(res.data.response.total_order_amount);
        setTotalOrderCount(res.data.response.total_order_count);
        setTotalUniqueSkuOrderCount(
          res.data.response.total_unique_sku_order_count
        );
      })
      .catch((error) => {
        setIsLoading(false);
        alert("Error encounter");
        console.log(error);
      });
  }

  function fetchVanAccountTransactions(searchTerm) {
    setIsLoading(true);
    const options = {
      method: "POST",
      url: "/TransactiSellerVanAccountTransactions/getTransactiSellerVanAccountTransactions.json",
      data: objectToFormData({
        search_term: searchTerm,
        status_filter: selectedStatusFilter,
        start_date: format(startingFilterDate, "yyyy-MM-dd"),
        end_date: format(endingFilterDate, "yyyy-MM-dd"),
        selectedSalesMan: selectedSalesMan,
      }),
    };
    axios(options)
      .then((res) => {
        setIsLoading(false);
        const isSuccess = res.data.response.is_success;

        if (!isSuccess) {
          alert("Error encounter");
          return;
        }

        setVanAccountTransactions(res.data.response.VanAccountTransactions);
        setVanOrderSummary(res.data.response);

        setPerOrderTotalUniqueSkuCount(
          res.data.response.per_order_total_unique_sku_count
        );
        setTotalOrderAmount(res.data.response.total_order_amount);
        setTotalOrderCount(res.data.response.total_order_count);
        setTotalUniqueSkuOrderCount(
          res.data.response.total_unique_sku_order_count
        );
      })
      .catch((error) => {
        setIsLoading(false);
        alert("Error encounter");
        console.log(error);
      });
  }

  useEffect(() => {
    if (!loadSalesMan) {
      return;
    }
    fetchSalesmanVisits("");
  }, [hasMoreAccountToLoad, loadSalesMan, reloadTab]);

  function fetchSalesmanVisits(searchTerm) {
    setIsLoading(true);
    setIsLoadingSalesman(true);
    const options = {
      method: "POST",
      url: "/TransactiSellerSalesOrder/fetchSalesmenVisits.json",
      data: objectToFormData({
        search_term: searchTerm,
        start_date: format(startingFilterDate, "yyyy-MM-dd"),
        end_date: format(endingFilterDate, "yyyy-MM-dd"),
        selectedSalesMan: selectedSalesMan,
        page_number: salesmanPageNumber,
      }),
    };
    axios(options)
      .then((res) => {
        setIsLoading(false);
        setIsLoadingSalesman(false);
        const isSuccess = res.data.response.is_success;

        if (!isSuccess) {
          alert("Error encounter");
          return;
        }

        const sales_man_visits = res.data.response.salesmen_visits;
        const sales_man_visit_summary = res.data.response.summary;

        setSalesmanVisitSummary(sales_man_visit_summary);
        setHasMoreAccountToLoad(sales_man_visits.length > 0);
        setLoadSalesMan(false);
        setSalesmanVisits(salesmanVisits.concat(sales_man_visits));
      })
      .catch((error) => {
        setIsLoading(false);
        setIsLoadingSalesman(false);
        alert("Error encounter");
      });
  }

  const objectToFormData = (object) =>
    Object.keys(object).reduce((formData, key) => {
      formData.append(key, object[key]);

      return formData;
    }, new FormData());

  function headerSummary() {
    const averageSalesPerOrder = !isNaN(
      Number(totalOrderAmount / totalOrderCount)
    )
      ? Number(totalOrderAmount / totalOrderCount).toLocaleString(undefined, {
          minimumFractionDigits: 2,
          maximumFractionDigits: 2,
        })
      : 0;

    const store_with_sales = sellerOrderSummary.number_of_stores_with_sales;
    const total_average_order =
      !isNaN(totalOrderAmount) &&
      !isNaN(store_with_sales) &&
      store_with_sales !== 0
        ? (totalOrderAmount / store_with_sales).toLocaleString(undefined, {
            minimumFractionDigits: 2,
            maximumFractionDigits: 2,
          })
        : 0;

    const average_unique_skus = !isNaN(
      Number(totalOrderAmount / store_with_sales)
    )
      ? Number(totalOrderAmount / store_with_sales).toLocaleString(undefined, {
          minimumFractionDigits: 2,
          maximumFractionDigits: 2,
        })
      : 0;

    return (
      <div className={classes.paper}>
        <Paper
          elevation={3}
          style={{ padding: "16px", backgroundColor: "#ffff00" }}
        >
          <Typography variant="body1" gutterBottom sx={{ fontWeight: "bold" }}>
            Date:{" "}
            {startingFilterDate.toDateString() ===
            endingFilterDate.toDateString()
              ? format(startingFilterDate, "MMM d, yyyy")
              : `${format(startingFilterDate, "MMM d, yyyy")} - ${format(
                  endingFilterDate,
                  "MMM d, yyyy"
                )}`}
          </Typography>
          <Typography variant="body1" gutterBottom sx={{ fontWeight: "bold" }}>
            Number of stores with sales:{" "}
            {sellerOrderSummary.number_of_stores_with_sales}
          </Typography>
          <Typography variant="body1" gutterBottom sx={{ fontWeight: "bold" }}>
            Total Order Amount: ₱
            {Number(totalOrderAmount).toLocaleString(undefined, {
              minimumFractionDigits: 2,
              maximumFractionDigits: 2,
            })}
          </Typography>
          <Typography variant="body1" gutterBottom sx={{ fontWeight: "bold" }}>
            Total Unique SKUs Ordered:{" "}
            {sellerOrderSummary.total_unique_sku_order_count}
          </Typography>
          <Button
            variant="contained"
            onClick={handleClickOpenBreakdown}
            style={{
              marginTop: "16px",
              backgroundColor: "green",
              color: "white",
            }}
          >
            View Breakdown
          </Button>
        </Paper>
      </div>
    );
  }

  useEffect(() => {
    if (selectedTab === "van_orders") {
      fetchVanAccountTransactions();
    }
  }, [selectedTab]);

  const renderHeaderSummary = () => {
    if (selectedTab === "bookings") {
      return <>{headerSummary()}</>;
    }

    if (selectedTab === "van_orders") {
      return <>{vanHeaderSummary()}</>;
    }

    if (selectedTab === "seller_store_visit") {
      return <>{sellerStoreVisitSummary()}</>;
    }
  };

  function vanHeaderSummary() {
    const averageSalesPerOrder = !isNaN(
      Number(totalOrderAmount / totalOrderCount)
    )
      ? Number(totalOrderAmount / totalOrderCount).toLocaleString(undefined, {
          minimumFractionDigits: 2,
          maximumFractionDigits: 2,
        })
      : 0;

    const store_with_sales = sellerOrderSummary.number_of_stores_with_sales;
    const total_average_order =
      !isNaN(totalOrderAmount) &&
      !isNaN(store_with_sales) &&
      store_with_sales !== 0
        ? (totalOrderAmount / store_with_sales).toLocaleString(undefined, {
            minimumFractionDigits: 2,
            maximumFractionDigits: 2,
          })
        : 0;

    const average_unique_skus = !isNaN(
      Number(totalOrderAmount / store_with_sales)
    )
      ? Number(totalOrderAmount / store_with_sales).toLocaleString(undefined, {
          minimumFractionDigits: 2,
          maximumFractionDigits: 2,
        })
      : 0;

    return (
      <div className={classes.paper}>
        <Paper
          elevation={3}
          style={{ padding: "16px" }}
          sx={{ backgroundColor: "yellow" }}
        >
          <Typography variant="body1" gutterBottom sx={{ fontWeight: "bold" }}>
            Date:{" "}
            {startingFilterDate.toDateString() ===
            endingFilterDate.toDateString()
              ? format(startingFilterDate, "MMM d, yyyy")
              : `${format(startingFilterDate, "MMM d, yyyy")} - ${format(
                  endingFilterDate,
                  "MMM d, yyyy"
                )}`}
          </Typography>
          <Typography variant="body1" gutterBottom sx={{ fontWeight: "bold" }}>
            Number of Stores Visited:{" "}
            {vanOrderSummary.total_number_of_store_visited}
          </Typography>
          <Typography variant="body1" gutterBottom sx={{ fontWeight: "bold" }}>
            Total Order Amount: ₱
            {Number(totalOrderAmount).toLocaleString(undefined, {
              minimumFractionDigits: 2,
              maximumFractionDigits: 2,
            })}
          </Typography>
          <Typography variant="body1" gutterBottom sx={{ fontWeight: "bold" }}>
            Total Unique SKUs Sold:{" "}
            {vanOrderSummary.total_unique_sku_order_count}
          </Typography>
          <Button
            variant="contained"
            onClick={handleClickOpenBreakdown}
            style={{ marginTop: "16px" }}
            sx={{ backgroundColor: "green", color: "white" }}
          >
            View Breakdown
          </Button>
        </Paper>
      </div>
    );
  }

  function sellerStoreVisitSummary() {
    return (
      <div className={classes.paper}>
        <Paper
          elevation={3}
          style={{ padding: "16px" }}
          sx={{ backgroundColor: "yellow" }}
        >
          <Typography variant="body1" gutterBottom sx={{ fontWeight: "bold" }}>
            Date:{" "}
            {startingFilterDate.toDateString() === new Date().toDateString() &&
            endingFilterDate.toDateString() === new Date().toDateString()
              ? format(startingFilterDate, "MMM d, yyyy")
              : `${format(startingFilterDate, "MMM d, yyyy")} - ${format(
                  endingFilterDate,
                  "MMM d, yyyy"
                )}`}
          </Typography>
          <Typography variant="body1" gutterBottom sx={{ fontWeight: "bold" }}>
            <strong>Number of Stores Visited:</strong>{" "}
            {salesmanVisitSummary.number_of_store_visited}
          </Typography>
          <Typography variant="body1" gutterBottom sx={{ fontWeight: "bold" }}>
            Total Order Amount: ₱
            {Number(salesmanVisitSummary.total_order_amount).toLocaleString(
              undefined,
              {
                minimumFractionDigits: 2,
                maximumFractionDigits: 2,
              }
            )}
          </Typography>
          <Typography variant="body1" gutterBottom sx={{ fontWeight: "bold" }}>
            Total Unique SKUs Sold: {salesmanVisitSummary.total_unique_sku_sold}
          </Typography>
          <Button
            variant="contained"
            onClick={handleClickOpenBreakdown}
            style={{ marginTop: "16px" }}
            sx={{ backgroundColor: "green", color: "white" }}
          >
            View Breakdown
          </Button>
        </Paper>
      </div>
    );
  }

  async function countTransactions() {
    setIsLoading(true);
    const options = {
      method: "POST",
      url: "/TransactiSellerSalesOrder/countTotalAccountTransactions.json",
      data: objectToFormData({
        status_filter: selectedStatusFilter,
        start_date: format(startingFilterDate, "yyyy-MM-dd"),
        end_date: format(endingFilterDate, "yyyy-MM-dd"),
      }),
    };

    try {
      const response = await axios(options);
      const count = await response.data.response.total;
      let limit = 20;

      setIsLoading(false);
      menuHandleClose();

      if (parseInt(count) > 0) {
        setShowCsvMessageDialog(true);
        const total_count = Math.ceil(count / limit);
        downloadTransactions(0, count, "");
      } else {
        setMessageDialogMessage("No Transaction Found");
        setShowMessageDialog(true);
      }
    } catch (error) {
      console.log(error);
    }
  }

  async function downloadTransactions(
    index,
    total_transactions,
    downloadCsvContent
  ) {
    let percent = (index / total_transactions) * 100;
    setCsvDownloadPercent(percent);

    if (index < total_transactions) {
      const options = {
        method: "POST",
        url: "/TransactiSellerSalesOrder/getTransactionsPerAccounts.json",
        data: objectToFormData({
          status_filter: selectedStatusFilter,
          start_date: format(startingFilterDate, "yyyy-MM-dd"),
          end_date: format(endingFilterDate, "yyyy-MM-dd"),
          index: index,
        }),
      };

      const response = await axios(options);
      const transactions = response.data.response.transactions;

      transactions.map((transaction) => {
        downloadCsvContent += transaction.account_code + ",";
        downloadCsvContent += transaction.account_name + ",";
        downloadCsvContent += transaction.sales_man + ",";
        downloadCsvContent += transaction.po_number + ",";
        downloadCsvContent += transaction.po_datetime + ",";
        downloadCsvContent += transaction.product_name + ",";
        downloadCsvContent += transaction.product_code + ",";
        downloadCsvContent += transaction.uom + ",";
        downloadCsvContent += transaction.quantity + ",";
        downloadCsvContent += transaction.price_with_tax + ",";
        downloadCsvContent += transaction.price_without_tax + ",";
        downloadCsvContent += "\n";
      });

      downloadTransactions(index + 20, total_transactions, downloadCsvContent);
    } else {
      let file_name = accountsLabel.singular + " Transactions";
      downloadFile(file_name, downloadCsvContent);
      setCsvDownloadPercent(0);
      setShowCsvMessageDialog(false);
    }
  }

  function downloadFile(file_name, csv_data) {
    const csv_header_arr = [
      accountsLabel.singular + " Code",
      accountsLabel.singular + " Name",
      "Sales Man",
      "PO Number",
      "PO DateTime",
      "Product Name",
      "Product Code",
      "Uom",
      "Quantity",
      "Price with tax",
      "Price without tax",
    ];

    const csv_header = csv_header_arr.join(",");
    let csv = csv_header + "\n" + csv_data;
    const url = "data:text/csv;charset=utf-8," + encodeURIComponent(csv);
    const link = document.createElement("a");
    link.href = url;
    link.setAttribute("download", `${file_name}.csv`);
    document.body.appendChild(link);
    link.click();
    link.remove();
  }

  const menuHandleClick = (event) => {
    setMenuAnchorEl(event.currentTarget);
  };

  const menuHandleClose = () => {
    setMenuAnchorEl(null);
  };

  function messageDialog() {
    return (
      <Dialog
        fullWidth={true}
        maxWidth={"sm"}
        open={showMessageDialog}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle id="alert-dialog-title">{"Message"}</DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-description">
            {messageDialogMessage}
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button
            onClick={() => {
              setShowMessageDialog(false);
            }}
            color="primary"
            autoFocus
          >
            Close
          </Button>
        </DialogActions>
      </Dialog>
    );
  }

  function CancelBookingReasonDialog() {
    return (
      <Dialog
        fullWidth={true}
        maxWidth={"sm"}
        open={showCancelBookingReasonDialog}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle id="alert-dialog-title">Cancel Booking Reason</DialogTitle>
        <DialogContent>
          <TextField
            hiddenLabel
            fullWidth
            id="outlined-basic"
            variant="outlined"
            value={cancelBookingReason}
            onChange={(e) => {
              setCancelBookingReason(e.target.value);
            }}
          />
        </DialogContent>
        <DialogActions>
          <Button
            onClick={() => {
              if (cancelBookingReason === "") {
                setShowMessageDialog(true);
                setMessageDialogMessage("Cancel Booking Reason is required.");
                return;
              }

              handleCancelBookingOrder();
            }}
            color="primary"
            autoFocus
          >
            Proceed
          </Button>

          <Button
            onClick={() => {
              setShowCancelBookingReasonDialog(false);
            }}
            color="primary"
            autoFocus
          >
            Close
          </Button>
        </DialogActions>
      </Dialog>
    );
  }

  function errorMessageDialog() {
    return (
      <Dialog
        fullWidth={true}
        maxWidth={"sm"}
        open={showErrorMessageDialog}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle id="alert-dialog-title">{"Message"}</DialogTitle>
        <DialogContent>
          <DialogContentText
            id="alert-dialog-description"
            style={{ color: "red" }}
          >
            {errorMessage}
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button
            onClick={() => {
              setShowErrorMessageDialog(false);
            }}
            color="primary"
            autoFocus
          >
            Close
          </Button>
        </DialogActions>
      </Dialog>
    );
  }

  function csvDownloadMessageDialog() {
    return (
      <Dialog
        fullWidth={true}
        maxWidth={"md"}
        open={showCsvMessageDialog}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle id="alert-dialog-title">CSV Download</DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-description">
            <LinearProgress variant="determinate" value={csvDownloadPercent} />
          </DialogContentText>
        </DialogContent>
      </Dialog>
    );
  }

  const handleCancelBookingOrder = async () => {
    const auto_generated_id = selectedSalesOrderForCancel.auto_generated_id;

    const options = {
      method: "POST",
      url: "/TransactiSellerSalesOrder/cancelBookingByAutoGeneratedId.json",
      data: objectToFormData({
        auto_generated_id: auto_generated_id,
        cancel_reason: cancelBookingReason,
      }),
    };

    setShowProgressDialog(true);
    setProgressDialogMessage("Cancelling Order... Please wait...");

    await axios(options)
      .then((res) => {
        const message = res.data.response.message;
        const isSuccess = res.data.response.is_success;

        setShowMessageDialog(isSuccess);
        setMessageDialogMessage(message);

        setIsLoading(false);
        setShowProgressDialog(false);

        if (isSuccess) {
          setShowCancelBookingReasonDialog(false);
          fetchAccountOrders();
          setReloadTab(true);
          setCancelBookingReason("");
        }
      })
      .catch((error) => {
        setIsLoading(false);
        setShowProgressDialog(false);

        setShowMessageDialog(true);
        setMessageDialogMessage(error);
      });
  };

  const handleClickOpenBreakdown = () => {
    fetchSalesOrderBreakdown();
    setOpenBreakdown(true);
  };

  const handleCloseBreakdown = () => {
    setOpenBreakdown(false);
    setBreakdownProducts([]);
  };

  const fetchSalesOrderBreakdown = async () => {
    setIsLoading(true);
    try {
      const orderStatusesArray = orderStatuses.map((item) => item.value);

      const response = await axios.post(
        "/TransactiSellerSalesOrder/getSellerSalesOrderProductBreakdown.json",
        objectToFormData({
          search_term: searchAccountTerm.name,
          status_filter: selectedStatusFilter,
          start_date: format(startingFilterDate, "yyyy-MM-dd"),
          end_date: format(endingFilterDate, "yyyy-MM-dd"),
          selectedSalesMan: selectedSalesMan,
          order_statuses: orderStatusesArray,
        })
      );

      const isSuccess = response.data.response.is_success;
      if (!isSuccess) {
        alert("Error encountered");
        return;
      }

      const so_generated_ids = response.data.response.sales_orders;
      setAutoGeneratedSalesOrderIds(so_generated_ids);
      setOrderStatusesBreakdown(response.data.response.order_statuses);
      await fetchSalesOrderItems(so_generated_ids);
    } catch (error) {
      console.error(error);
    }
  };

  async function fetchSalesOrderItems(ids) {
    for (let i = 0; i < ids.length; i++) {
      try {
        const response = await axios.post(
          "/TransactiSellerSalesOrder/getSalesOrderItemsByAutoGeneratedId.json",
          objectToFormData({ so_generated_id: ids[i] })
        );

        const isSuccess = response.data.response.is_success;
        if (!isSuccess) {
          alert("Error encountered");
          return;
        }
        let sales_order_items = response.data.response.sales_order_items;
        sales_order_items.forEach((item) => {
          // Check if a product with the same product_code and uom exists in breakdownProducts
          const existingProductIndex = breakdownProducts.findIndex(
            (product) => product.product_code === item.product_code
          );

          if (existingProductIndex !== -1) {
            // Product exists, update the uom property
            const productToUpdate = breakdownProducts[existingProductIndex];

            if (productToUpdate.uom.hasOwnProperty(item.uom)) {
              // Update existing uom with new values
              productToUpdate.uom[item.uom].order_quantity += parseFloat(
                item.order_quantity
              );
            } else {
              // Create a new uom entry
              productToUpdate.uom[item.uom] = {
                order_quantity: parseFloat(item.order_quantity),
                price_with_tax: parseFloat(item.price_with_tax),
              };
            }
          } else {
            // Product doesn't exist, create a new item and add it to breakdownProducts
            const newItem = {
              product_code: item.product_code,
              product_name: item.product_name,
              uom: {
                [item.uom]: {
                  order_quantity: parseFloat(item.order_quantity),
                  price_with_tax: parseFloat(item.price_with_tax),
                },
              },
            };
            breakdownProducts.push(newItem); // Add the new item to the original array
          }
        });
        setBreakdownProducts([...breakdownProducts]);
      } catch (error) {
        console.error(error);
      }
    }
    setIsLoading(false);
  }

  function generateBreakdown() {
    return (
      <List>
        {breakdownProducts.map((product, index) => (
          <ListItem divider key={"product_" + index}>
            <ListItemText
              primary={product.product_name}
              secondary={product.product_code}
            />
            <List>
              {Object.keys(product.uom).map((uom, uomIndex) => (
                <ListItem key={"uom_" + uomIndex}>
                  <Box display="flex" justifyContent="space-between">
                    {renderUOMInfo(uom, product.uom[uom])}
                    <Typography sx={{ color: "green", fontWeight: "bold" }}>
                      ₱
                      {calculateUOMTotal(product.uom[uom]).toLocaleString(
                        undefined,
                        {
                          minimumFractionDigits: 2,
                          maximumFractionDigits: 2,
                        }
                      )}
                    </Typography>
                  </Box>
                </ListItem>
              ))}
            </List>
          </ListItem>
        ))}
      </List>
    );
  }

  function renderUOMInfo(uom, uomData) {
    return (
      <>
        <Typography>
          {uomData.order_quantity} {uom} x {uomData.price_with_tax} =&nbsp;
        </Typography>
      </>
    );
  }

  function calculateUOMTotal(uomData) {
    return uomData.order_quantity * uomData.price_with_tax;
  }

  useEffect(() => {
    if (!assignOrderForDelivery) {
      return;
    }

    setProgressDialogMessage("Assigning order for delivery. Please wait...");
    setShowProgressDialog(true);
    setAssignOrderForDelivery(false);

    const options = {
      method: "POST",
      url: "/TransactiSellerSalesOrder/assignOrder.json",
      data: objectToFormData({
        sales_order_id: selectedOrderToAssignForDelivery.id,
        order_auto_generated_id:
          selectedOrderToAssignForDelivery.auto_generated_id,
        account_code: selectedOrderToAssignForDelivery.account_code,
        assign_to_username: selectedDeliveryPersonel,
      }),
    };

    axios(options)
      .then((res) => {
        setShowProgressDialog(false);

        const response_data = res.data.response;

        const is_success = response_data.is_success;
        const message = response_data.message;

        if (!is_success) {
          setShowErrorMessageDialog(true);
          setErrorMessage(message);
        } else {
          setShowMessageDialog(true);
          setMessageDialogMessage(response_data.message);

          fetchAccountOrders("");
        }
      })
      .catch((err) => {
        setShowProgressDialog(false);
        console.log(err);
      });
  }, [assignOrderForDelivery]);
  useEffect(() => {
    if (!doneUpdatingStatus) {
      return;
    }

    setReloadTab(true);
    if (updateStatusErrors.length <= 0) {
      setShowUpdateStatusDialog(false);
      setUpdateOrderStatusProgress(false);
      setShowUpdateOrderStatusDialog(false);
      setMessageDialogMessage("Orders status successfully updated.");
      setShowMessageDialog(true);

      setDoneUpdatingStatus(false);
    }
  }, [doneUpdatingStatus]);

  useEffect(() => {
    if (!isDoneUploadingCSV) {
      return;
    }

    if (uploadCSVErrors.length <= 0) {
      setShowUpdateStatusDialog(false);
      setShowUploadCSVDialog(false);

      setMessageDialogMessage(
        "User Delivery assignment successfully uploaded."
      );
      setShowMessageDialog(true);

      setUploadCSVDialogTitle("");
      setDoneUpdatingStatus(false);
    }
  }, [isDoneUploadingCSV]);

  const handleShowUpdateOrderStatusDialog = () => {
    setShowUpdateStatusDialog(true);
    setMenuAnchorEl(null);
  };

  const updateStatusDialog = () => {
    return (
      <Dialog fullWidth={true} maxWidth={"md"} open={showUpdateStatusDialog}>
        <DialogTitle>Update order status via CSV</DialogTitle>
        <DialogContent>
          <Box
            p={1}
            display="flex"
            justifyContent="left"
            flexDirection="column"
          >
            <input
              accept=".csv"
              type="file"
              onChange={toUpdateOrderStatusOnInputChange}
            />
            <br />
          </Box>
          <Button
            variant="contained"
            style={{ marginRight: "5px" }}
            color="primary"
            onClick={() => {
              handleProcessDownloadOrders();
            }}
          >
            <FileDownloadIcon /> Download template with orders
          </Button>
        </DialogContent>
        <DialogActions>
          <Button
            onClick={() => {
              readToUpdateOrderStatusCsv(csvFile);
            }}
            color="primary"
          >
            Continue
          </Button>
          <Button
            onClick={() => {
              setShowUpdateStatusDialog(false);
            }}
            color="primary"
            autoFocus
          >
            Close
          </Button>
        </DialogActions>
      </Dialog>
    );
  };

  const handleShowAssignDeliverieOrdersDialog = () => {
    setShowAssignOrderDeliveriesDialog(true);
    setMenuAnchorEl(null);
  };

  const assignOrderDeliveriesDialog = () => {
    return (
      <Dialog
        fullWidth={true}
        maxWidth={"md"}
        open={showAssignOrderDeliveriesDialog}
      >
        <DialogTitle>Assign order for delivery via CSV</DialogTitle>
        <DialogContent>
          <Box
            p={1}
            display="flex"
            justifyContent="left"
            flexDirection="column"
          >
            <input
              accept=".csv"
              type="file"
              onChange={toUpdateOrderStatusOnInputChange}
            />
            <br />
          </Box>
          <Button
            variant="contained"
            style={{ marginRight: "5px" }}
            color="primary"
            onClick={() => {
              handleProcessDownloadTransactions();
            }}
          >
            <FileDownloadIcon /> Download template with transaction
          </Button>
        </DialogContent>
        <DialogActions>
          <Button
            onClick={() => {
              readToAssignDeliveryOrderCsv(csvFile);
            }}
            color="primary"
          >
            Continue
          </Button>
          <Button
            onClick={() => {
              setShowAssignOrderDeliveriesDialog(false);
            }}
            color="primary"
            autoFocus
          >
            Close
          </Button>
        </DialogActions>
      </Dialog>
    );
  };

  const handleProcessDownloadTransactions = async () => {
    try {
      const count = await countTotalOrders();
      const limit = 100;
      const total_page = Math.ceil(count / limit);

      if (count > 0) {
        setIsDownloadingOrders(true);
        await fetchTransactionsForCSVDownload(0, limit, total_page, "");
      } else {
        setShowMessageDialog(true);
        setMessageDialogMessage("Orders is empty.");
      }
    } catch (err) {
      setShowMessageDialog(true);
      setMessageDialogMessage(err);
    }
  };

  const fetchTransactionsForCSVDownload = async (
    offset = 0,
    limit,
    total_page,
    downloadCsvContent
  ) => {
    const options = {
      method: "POST",
      url: "/TransactiSellerSalesOrder/downloadTransactiSellerOrders.json",
      data: objectToFormData({
        search_term: searchAccountTerm.name,
        status_filter: selectedStatusFilter,
        start_date: format(startingFilterDate, "yyyy-MM-dd"),
        end_date: format(endingFilterDate, "yyyy-MM-dd"),
        offset: offset,
        limit: limit,
        downloadType: "transactions",
      }),
    };

    let progress =
      (offset / total_page) * 100 < 100 ? (offset / total_page) * 100 : 100;
    setDownloadOrdersProgress(progress);

    if (total_page > offset) {
      axios(options)
        .then((res) => {
          const orders = res.data.response.orders;

          setTransactionsCSV((prevOrders) => [...prevOrders, ...orders]);

          fetchTransactionsForCSVDownload(
            offset + 100,
            limit,
            total_page,
            downloadCsvContent
          );
        })
        .catch((err) => {
          setIsDownloadingOrders(false);
          setShowMessageDialog(true);
          setMessageDialogMessage(err);
        });
    } else {
      setIsDoneDownloadingTransactions(true);
      setIsDownloadingOrders(false);
    }
  };

  useEffect(() => {
    if (!doneDownloadingTransactions) {
      return false;
    }

    if (transactionsCSV.length == 0) {
      return false;
    }

    const downloadTransactionCSVFile = () => {
      const csv = Papa.unparse(transactionsCSV);

      // Create a Blob object with the CSV data
      const blob = new Blob([csv], { type: "text/csv;charset=utf-8" });

      // Create a link element and trigger a click to download the file
      const link = document.createElement("a");
      link.href = URL.createObjectURL(blob);
      link.download = "for_delivery_assignment_csv_template" || "data.csv";
      link.click();

      setTransactionsCSV([]);
      setIsDoneDownloadingTransactions(false);
    };

    downloadTransactionCSVFile();
  }, [transactionsCSV, doneDownloadingTransactions]);

  const handleProcessDownloadOrders = async () => {
    try {
      const count = await countTotalOrders();
      const limit = 100;
      const total_page = Math.ceil(count / limit);

      if (count > 0) {
        setIsDownloadingOrders(true);
        await fetchOrdersForCSVDownload(0, limit, total_page, "");
      } else {
        setShowMessageDialog(true);
        setMessageDialogMessage("Orders is empty.");
      }
    } catch (err) {
      setShowMessageDialog(true);
      setMessageDialogMessage(err);
    }
  };

  const countTotalOrders = () => {
    return new Promise((resolve, reject) => {
      const options = {
        method: "POST",
        url: "/TransactiSellerSalesOrder/countTransactiSellerSalesOrder.json",
        data: objectToFormData({
          search_term: searchAccountTerm.name,
          status_filter: selectedStatusFilter,
          start_date: format(startingFilterDate, "yyyy-MM-dd"),
          end_date: format(endingFilterDate, "yyyy-MM-dd"),
        }),
      };

      axios(options)
        .then((res) => {
          try {
            const total = res.data.response.total_order_count;
            resolve(total);
          } catch (err) {
            reject(err);
          }
        })
        .catch((err) => {
          reject(err);
        });
    });
  };

  const fetchOrdersForCSVDownload = async (
    offset = 0,
    limit,
    total_page,
    downloadCsvContent
  ) => {
    const options = {
      method: "POST",
      url: "/TransactiSellerSalesOrder/downloadTransactiSellerOrders.json",
      data: objectToFormData({
        search_term: searchAccountTerm.name,
        status_filter: selectedStatusFilter,
        start_date: format(startingFilterDate, "yyyy-MM-dd"),
        end_date: format(endingFilterDate, "yyyy-MM-dd"),
        offset: offset,
        limit: limit,
      }),
    };

    let progress =
      (offset / total_page) * 100 < 100 ? (offset / total_page) * 100 : 100;
    setDownloadOrdersProgress(progress);

    if (total_page > offset) {
      axios(options)
        .then((res) => {
          const orders = res.data.response.orders;

          setOrdersCSV((prevOrders) => [...prevOrders, ...orders]);

          fetchOrdersForCSVDownload(
            offset + 100,
            limit,
            total_page,
            downloadCsvContent
          );
        })
        .catch((err) => {
          setIsDownloadingOrders(false);
          setShowMessageDialog(true);
          setMessageDialogMessage(err);
        });
    } else {
      setIsDoneDownloadingOrders(true);
      setIsDownloadingOrders(false);
    }
  };

  useEffect(() => {
    if (!doneDownloadingOrders) {
      return false;
    }

    if (ordersCSV.length == 0) {
      return false;
    }

    const downloadFile = () => {
      const csv = Papa.unparse(ordersCSV);

      // Create a Blob object with the CSV data
      const blob = new Blob([csv], { type: "text/csv;charset=utf-8" });

      // Create a link element and trigger a click to download the file
      const link = document.createElement("a");
      link.href = URL.createObjectURL(blob);
      link.download = "update_order_status_csv_template" || "data.csv";
      link.click();

      setOrdersCSV([]);
      setIsDoneDownloadingOrders(false);
    };

    downloadFile();
  }, [ordersCSV, doneDownloadingOrders]);

  const toUpdateOrderStatusOnInputChange = (event) => {
    let file = event.target.files;
    setCsvFile(file);
  };

  function downloadOrdersProgressDialog() {
    return (
      <Dialog
        fullWidth={true}
        maxWidth={"lg"}
        open={isDownloadingOrders}
        onClose={() => {}}
      >
        <DialogContent>
          <DialogContentText>
            Downloading Orders... Please wait...
          </DialogContentText>
          <Box sx={{ width: "100%" }}>
            <LinearProgress
              color="secondary"
              variant="determinate"
              value={downloadOrdersProgress}
            />
          </Box>
        </DialogContent>
      </Dialog>
    );
  }

  const readToUpdateOrderStatusCsv = async (csvFile) => {
    try {
      let file = csvFile[0];
      let is_valid_file = file !== undefined && file.type === "text/csv";

      if (!is_valid_file) {
        setShowMessageDialog(true);
        setMessageDialogMessage("Please select a valid csv file");
        return;
      }

      let csv_data = await readCsv(file);
      let csv_header = csv_data.header;
      let csv_values = csv_data.data;
      let missingHeaders = getMissingHeaders(
        csv_header,
        updateOrderStatusCSVHeader
      );

      if (csv_header.length <= 0) {
        setShowMessageDialog(true);
        setMessageDialogMessage("Check your csv header");
        return;
      }
      if (missingHeaders.length > 0) {
        setShowMessageDialog(true);
        setMessageDialogMessage(
          "The following headers must be in your CSV header: " +
            missingHeaders.join(", ")
        );
        return;
      }

      let upload_data_limit = 20;
      uploadOrderStatusToUpdate(
        upload_data_limit,
        csv_values,
        csv_values.length
      );

      setShowUpdateOrderStatusDialog(true);
    } catch (error) {
      console.error("Failed to parse CSV:", error);
    }
  };

  const readToAssignDeliveryOrderCsv = async (csvFile) => {
    try {
      let file = csvFile[0];
      let is_valid_file = file !== undefined && file.type === "text/csv";

      if (!is_valid_file) {
        setShowMessageDialog(true);
        setMessageDialogMessage("Please select a valid csv file");
        return;
      }

      let csv_data = await readCsv(file);
      let csv_header = csv_data.header;
      let csv_values = csv_data.data;
      let missingHeaders = getMissingHeaders(
        csv_header,
        forDeliveryAssignmentCSVHeader
      );

      if (csv_header.length <= 0) {
        setShowMessageDialog(true);
        setMessageDialogMessage("Check your csv header");
        return;
      }
      if (missingHeaders.length > 0) {
        setShowMessageDialog(true);
        setMessageDialogMessage(
          "The following headers must be in your CSV header: " +
            missingHeaders.join(", ")
        );
        return;
      }

      setUploadCSVDialogTitle("Upload Delivery Assignment");
      setShowAssignOrderDeliveriesDialog(false);

      let csv_line = 1;
      let upload_data_limit = 20;
      uploadUserDeliveryAssignment(
        upload_data_limit,
        csv_values,
        csv_values.length,
        csv_line
      );

      setShowUploadCSVDialog(true);
    } catch (error) {
      console.error("Failed to parse CSV:", error);
    }
  };

  const uploadUserDeliveryAssignment = (
    upload_data_limit,
    data_to_upload,
    total_record_count,
    csv_line
  ) => {
    // Get the first two records
    const chunk_of_data_to_upload = data_to_upload.slice(0, upload_data_limit);

    // Update data_to_upload by removing data to upload
    data_to_upload.splice(0, upload_data_limit);

    var assignment = JSON.stringify(chunk_of_data_to_upload);

    const options = {
      method: "POST",
      url: "/TransactiSellerSalesOrder/uploadUserDeliveryAssignment.json",
      data: objectToFormData({ assignment: assignment, csv_line: csv_line }),
    };

    axios(options)
      .then((res) => {
        const result = res.data.result;
        const errors = result.errors;
        const remaining_data_to_update = data_to_upload.length;
        const progress =
          ((total_record_count - remaining_data_to_update) /
            total_record_count) *
          100;

        setUploadCSVErrors((uploadCSVErrors) => [
          ...uploadCSVErrors,
          ...errors,
        ]);

        setUploadCSVProgress(progress);
        if (data_to_upload.length > 0) {
          uploadUserDeliveryAssignment(
            upload_data_limit,
            data_to_upload,
            total_record_count,
            csv_line + 20
          );
        } else {
          setIsDoneUploadingCSV(true);
        }
      })
      .catch((error) => {
        setMessageDialogMessage(error);
        setShowMessageDialog(true);
      });
  };

  function uploadCSVProgressDialog() {
    return (
      <Dialog fullWidth={true} maxWidth={"md"} open={showUploadCSVDialog}>
        <DialogTitle>{uploadCSVDialogTitle}</DialogTitle>
        <DialogContent>
          <LinearProgress
            sx={{ height: 10 }}
            variant="determinate"
            value={uploadCSVProgress}
          />
          {uploadCSVProgessAndStatusTable()}
        </DialogContent>
        <DialogActions>
          <Button
            onClick={() => {
              setShowUpdateOrderStatusDialog(false);
              setShowUploadCSVDialog(false);
              window.location.reload();
            }}
            color="primary"
            autoFocus
          >
            Close
          </Button>
        </DialogActions>
      </Dialog>
    );
  }

  function uploadCSVProgessAndStatusTable() {
    if (uploadCSVErrors.length > 0) {
      return (
        <TableContainer component={Paper}>
          <Table sx={{ minWidth: 500 }} id="status_tbl">
            <TableHead>
              <TableRow>
                <TableCell>
                  <b>CSV Line</b>
                </TableCell>
                <TableCell>
                  <b>Error message</b>
                </TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {uploadCSVErrors.map((value, index) => (
                <TableRow key={index}>
                  <TableCell>{value.csv_line}</TableCell>
                  <TableCell>{value.message}</TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </TableContainer>
      );
    } else {
      return "";
    }
  }

  function accountDeleteProgressAndStatusDialog() {
    return (
      <Dialog
        fullWidth={true}
        maxWidth={"md"}
        open={showUpdateOrderStatusDialog}
      >
        <DialogTitle>Update order status progress</DialogTitle>
        <DialogContent>
          <LinearProgress
            sx={{ height: 10 }}
            variant="determinate"
            value={updateOrderStatusProgress}
          />
          {orderStatusUpdateProgressAndStatusTable()}
        </DialogContent>
        <DialogActions>
          <Button
            onClick={() => {
              setShowUpdateOrderStatusDialog(false);
              setShowUpdateStatusDialog(false);
              window.location.reload();
            }}
            color="primary"
            autoFocus
          >
            Close
          </Button>
        </DialogActions>
      </Dialog>
    );
  }

  function orderStatusUpdateProgressAndStatusTable() {
    if (updateStatusErrors.length > 0) {
      return (
        <TableContainer component={Paper}>
          <Table sx={{ minWidth: 500 }} id="status_tbl">
            <TableHead>
              <TableRow>
                <TableCell>
                  <b>Error message</b>
                </TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {updateStatusErrors.map((value, index) => (
                <TableRow key={index}>
                  <TableCell>{value}</TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </TableContainer>
      );
    } else {
      return "";
    }
  }

  const uploadOrderStatusToUpdate = (
    upload_data_limit,
    data_to_upload,
    total_record_count
  ) => {
    // Get the first two records
    const chunk_of_data_to_upload = data_to_upload.slice(0, upload_data_limit);

    // Update data_to_upload by removing data to upload
    data_to_upload.splice(0, upload_data_limit);

    var orders = JSON.stringify(chunk_of_data_to_upload);

    const options = {
      method: "POST",
      url: "/TransactiSellerSalesOrder/updateOrderStatusViaCSVUpload.json",
      data: objectToFormData({ orders: orders }),
    };

    axios(options)
      .then((res) => {
        const result = res.data.result;
        const errors = result.errors;
        const remaining_data_to_update = data_to_upload.length;
        const progress =
          ((total_record_count - remaining_data_to_update) /
            total_record_count) *
          100;

        setUpdateStatusErrors((updateStatusErrors) => [
          ...updateStatusErrors,
          ...errors,
        ]);
        setUpdateOrderStatusProgress(progress);

        if (data_to_upload.length > 0) {
          uploadOrderStatusToUpdate(
            upload_data_limit,
            data_to_upload,
            total_record_count
          );
        } else {
          setDoneUpdatingStatus(true);
        }
      })
      .catch((error) => {
        setMessageDialogMessage(error);
        setShowMessageDialog(true);
      });
  };

  function getMissingHeaders(csvHeaderArray, requiredHeaderArray) {
    return requiredHeaderArray.filter(
      (header) => !csvHeaderArray.includes(header)
    );
  }

  function readCsv(csvFile) {
    return new Promise((resolve, reject) => {
      Papa.parse(csvFile, {
        header: true,
        skipEmptyLines: true,
        complete: function (results) {
          resolve({ header: results.meta.fields, data: results.data });
        },
        error: function (error) {
          reject(error);
        },
      });
    });
  }

  const pageTabs = () => {
    return (
      <ThemeProvider theme={materialTheme}>{renderPageTabs()}</ThemeProvider>
    );
  };

  const renderPageTabs = () => {
    //  Lead store with booking seller
    if (transactiUserTypeCode === "LSWBS") {
      return (
        <>
          <Tabs value={tabValue} onChange={handleChange}>
            <Tab
              label="Booking Orders"
              onClick={() => setSelectedTab("bookings")}
            />

            <Tab
              label="Seller Store Visit"
              onClick={() => setSelectedTab("seller_store_visit")}
            />
          </Tabs>
        </>
      );
    }

    // Lead store with van seller
    if (transactiUserTypeCode === "LSWVS") {
      return (
        <>
          <Tabs value={tabValue} onChange={handleChange}>
            <Tab
              label="Van Orders"
              onClick={() => setSelectedTab("van_orders")}
            />

            <Tab
              label="Seller Store Visit"
              onClick={() => setSelectedTab("seller_store_visit")}
            />
          </Tabs>
        </>
      );
    }

    // Lead store with booking and van seller
    if (transactiUserTypeCode === "LSWBAVS") {
      return (
        <>
          <Tabs value={tabValue} onChange={handleChange}>
            <Tab
              label="Booking Orders"
              onClick={() => setSelectedTab("bookings")}
            />
            <Tab
              label="Van Orders"
              onClick={() => setSelectedTab("van_orders")}
            />
            <Tab
              label="Seller Store Visit"
              onClick={() => setSelectedTab("seller_store_visit")}
            />
          </Tabs>
        </>
      );
    }
  };

  const orders = () => {
    return (
      <List ref={accountsElement}>
        {salesOrders.map((salesOrder, index) => {
          return salesOrders.length === index + 1 ? (
            <div key={salesOrder.id}>
              <ListItem
                button
                divider
                style={{
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "flex-start",
                  padding: "0px",
                }}
              >
                {salesOrderElement(salesOrder)}
              </ListItem>
            </div>
          ) : (
            <div key={salesOrder.id}>
              <ListItem
                button
                divider
                style={{
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "flex-start",
                  padding: "0px",
                }}
              >
                {salesOrderElement(salesOrder)}
              </ListItem>
            </div>
          );
        })}
      </List>
    );
  };

  const vanOrders = () => {
    return (
      <List ref={VanAccountElement}>
        {vanAccountTransactions.map((vanAccountTransaction, index) => (
          <div key={vanAccountTransaction.id}>
            <ListItem
              button
              divider
              style={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "flex-start",
                padding: "0px",
              }}
              ref={
                index === vanAccountTransaction.length - 1
                  ? accountsElement
                  : null
              } // Add ref only to the last item
            >
              {vanAccountTransactionElements(vanAccountTransaction)}
            </ListItem>
          </div>
        ))}
      </List>
    );
  };

  function vanAccountTransactionElements(vanAccountTransaction) {
    return (
      <div style={{ width: "100%" }}>
        <Grid container>
          <Grid container>
            <Grid item xs={12} lg={12}>
              <Box sx={{ marginTop: ".5em" }}>
                <Typography variant="h6">
                  {vanAccountTransaction.Account.account_name}
                </Typography>
              </Box>

              {vanAccountTransaction.Account.street != "" &&
                vanAccountTransaction.Account.barangay != "" &&
                vanAccountTransaction.Account.street != "" && (
                  <Box sx={{ marginBottom: ".5em" }}>
                    <Typography variant="body" gutterBottom>
                      {vanAccountTransaction.Account.street},{" "}
                      {vanAccountTransaction.Account.barangay}{" "}
                      {vanAccountTransaction.Account.city_municipality}
                    </Typography>
                  </Box>
                )}
            </Grid>
          </Grid>

          <Grid
            item
            xs={vanAccountTransaction.booking_status === 0 ? 12 : 7}
            lg={7}
          >
            <Typography gutterBottom variant="subtitle1">
              Order date: {formatDate(vanAccountTransaction.po_datetime)}
              <br />
              Total value:{" "}
              {Number(vanAccountTransaction.total_amount).toLocaleString(
                undefined,
                {
                  minimumFractionDigits: 2,
                  maximumFractionDigits: 2,
                }
              )}
              <br />
              Order Status: {renderOrderStatusValue(vanAccountTransaction)}
              <br />
            </Typography>
          </Grid>

          <Grid
            item
            xs={5}
            lg={5}
            sx={{ display: "flex", flexDirection: "column" }}
          >
            {renderViewVanAccountItems(vanAccountTransaction)}
          </Grid>
        </Grid>
      </div>
    );
  }

  const renderViewVanAccountItems = (vanAccountTransaction) => {
    return (
      <Box
        display="flex"
        sx={{
          justifyContent: { xs: "center", sm: "center", md: "flex-end" },
          marginTop: "2em",
        }}
      >
        <Button
          size="small"
          autoFocus
          sx={{
            backgroundColor: "yellow",
            "&:hover": { backgroundColor: "yellow" },
            color: "black",
            marginTop: ".5em",
            marginLeft: { xs: ".4em" },
          }}
          onClick={(e) => {
            e.stopPropagation();
            setSelectedVanAccountTransaction(vanAccountTransaction);
            setOpenVanAccountItemsDialog(true);
          }}
        >
          View Items
        </Button>
      </Box>
    );
  };

  const sellers = () => {
    return (
      <List ref={sellerOrdersElement}>
        {salesmanVisits.map((salesman_visit, index) => {
          return salesmanVisits.length === index + 1 ? (
            <div key={`${salesman_visit.full_name}_${index}`}>
              <ListItem
                ref={lastSalesmanElement}
                button
                divider
                style={{
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "flex-start",
                }}
              >
                {SalesmanVisitElement(salesman_visit)}
              </ListItem>
            </div>
          ) : (
            <div key={`${salesman_visit.full_name}_${index}`}>
              <ListItem
                button
                divider
                style={{
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "flex-start",
                }}
              >
                {SalesmanVisitElement(salesman_visit)}
              </ListItem>
            </div>
          );
        })}
      </List>
    );
  };

  function DeprecatedSalesmanVisitElement(salesman_visit) {
    const totalOrderAmount = salesman_visit.total_sales_order_per_salesman;
    const totalOrderCount = salesman_visit.total_order_count;

    const averageSalesPerOrder = !isNaN(
      Number(totalOrderAmount / totalOrderCount)
    )
      ? Number(totalOrderAmount / totalOrderCount).toLocaleString(undefined, {
          minimumFractionDigits: 2,
          maximumFractionDigits: 2,
        })
      : 0;

    const perOrderTotalUniqueSkuCount =
      salesman_visit.per_order_total_unique_sku_count;
    const averageUniqueSkuPerOrder = !isNaN(
      Number(perOrderTotalUniqueSkuCount / totalOrderCount)
    )
      ? Number(perOrderTotalUniqueSkuCount / totalOrderCount).toLocaleString(
          undefined,
          {
            minimumFractionDigits: 2,
            maximumFractionDigits: 2,
          }
        )
      : 0;

    return (
      <>
        <Grid container>
          <Grid container>
            <Grid item xs={12} lg={11}>
              <Typography variant="h6" gutterBottom>
                {salesman_visit.full_name}
              </Typography>
            </Grid>
          </Grid>
          <Grid item xs={12} lg={9}>
            <Typography variant="subtitle1">
              {/* Number of stores visited: <b>{salesman_visit.visits}</b>
              <br /> */}
              Number of stores with sales:{" "}
              <b>{salesman_visit.visits_w_sales}</b>
              <br />
              {/* Order fullfiled ( Delivered ):{" "}
              <b>{salesman_visit.total_orders_fulfilled}</b>
              <br /> */}
              Total order value :{" "}
              <b>
                {Number(
                  salesman_visit.total_sales_order_per_salesman
                ).toLocaleString(undefined, {
                  minimumFractionDigits: 2,
                  maximumFractionDigits: 2,
                })}{" "}
              </b>
              <br />
              {/* Average order per store : <b>{averageSalesPerOrder}</b>
              <br /> */}
              {/* Average unique SKUs per order : <b>{averageUniqueSkuPerOrder}</b>
              <br /> */}
              Total unique sku sold :{" "}
              <b>{salesman_visit.total_unique_sku_per_salesman}</b>
              <br />
              {/* Total number of stores with order fulfilled :{" "}
              <b>{salesman_visit.total_stores_with_order_fulfilled}</b>
              <br /> */}
            </Typography>
          </Grid>
        </Grid>
      </>
    );
  }

  function SalesmanVisitElement(salesman_visit) {
    return (
      <>
        <Grid container>
          <Grid container>
            <Grid item xs={12} lg={11}>
              <Typography variant="h6" gutterBottom>
                {salesman_visit.full_name}
              </Typography>
            </Grid>
          </Grid>
          <Grid item xs={12} lg={9}>
            <Typography variant="subtitle1">
              Number of stores with sales:{" "}
              <b>{salesman_visit.visits_w_sales}</b>
              <br />
              Total order value :{" "}
              <b>
                {Number(
                  salesman_visit.total_sales_order_per_salesman
                ).toLocaleString(undefined, {
                  minimumFractionDigits: 2,
                  maximumFractionDigits: 2,
                })}{" "}
              </b>
              <br />
              Total unique sku sold :{" "}
              <b>{salesman_visit.total_unique_sku_per_salesman}</b>
              <br />
            </Typography>
          </Grid>
        </Grid>
      </>
    );
  }

  const tabPanels = () => {
    if (transactiUserTypeCode === "LSWBS") {
      return (
        <>
          <TabPanel value={tabValue} index={0}>
            {orders()}
          </TabPanel>
          <TabPanel value={tabValue} index={1}>
            {sellers()}
          </TabPanel>
        </>
      );
    }

    if (transactiUserTypeCode === "LSWVS") {
      return (
        <>
          <TabPanel value={tabValue} index={0}>
            {vanOrders()}
          </TabPanel>
          <TabPanel value={tabValue} index={1}>
            {sellers()}
          </TabPanel>
        </>
      );
    }

    if (transactiUserTypeCode === "LSWBAVS") {
      return (
        <>
          <TabPanel value={tabValue} index={0}>
            {orders()}
          </TabPanel>
          <TabPanel value={tabValue} index={1}>
            {vanOrders()}
          </TabPanel>
          <TabPanel value={tabValue} index={2}>
            {sellers()}
          </TabPanel>
        </>
      );
    }
  };

  return (
    <div>
      <CssBaseline />
      {pageTabs()}
      <Dialog fullScreen open={openBreakdown} onClose={handleCloseBreakdown}>
        <AppBar sx={{ position: "relative" }}>
          <Toolbar>
            <IconButton
              edge="start"
              color="inherit"
              onClick={handleCloseBreakdown}
            >
              <CloseIcon />
            </IconButton>
            <Typography sx={{ ml: 2, flex: 1 }} variant="h6" component="div">
              Order Summary Breakdown
            </Typography>
          </Toolbar>
        </AppBar>
        {isLoading ? (
          <LinearProgress
            color="secondary"
            style={{ marginLeft: ".1rem", marginRight: ".1rem" }}
          />
        ) : (
          ""
        )}
        <Box className={classes.paper}>
          <Paper elevation={3} className={classes.summaryPaper}>
            <div className={classes.summaryDetails}>
              <div className={classes.summaryDetail}>
                <Typography variant="subtitle1">
                  <strong>Date Range: </strong>
                  {format(startingFilterDate, "MMM d, yyyy")} -{" "}
                  {format(endingFilterDate, "MMM d, yyyy")}
                </Typography>
              </div>
              <div className={classes.summaryDetail}>
                <Typography variant="subtitle1">
                  <strong>Status Filter: </strong>
                  {selectedStatusFilter === 0
                    ? "Pending Orders"
                    : selectedStatusFilter == 1
                    ? "Invoiced Orders"
                    : "All Orders"}
                </Typography>
              </div>
              <hr />
              <div className={classes.summaryDetail}>
                <Typography variant="subtitle1">
                  <strong>Total Order: </strong>₱
                  {Number(totalOrderAmount).toLocaleString(undefined, {
                    minimumFractionDigits: 2,
                    maximumFractionDigits: 2,
                  })}
                </Typography>
              </div>
              <div className={classes.summaryDetail}>
                <Typography variant="subtitle1">
                  <strong>Total Unique SKUs ordered: </strong>
                  {totalUniqueSkuOrderCount}
                </Typography>
              </div>
              <div className={classes.summaryDetail}>
                <Typography variant="subtitle1">
                  <strong>Total number of orders: </strong>
                  {totalOrderCount}
                </Typography>
              </div>
              <div className={classes.summaryDetail}>
                <Typography variant="subtitle1">
                  <strong>Average sales per order: </strong>₱
                  {!isNaN(
                    Number(totalOrderAmount / totalOrderCount).toLocaleString(
                      undefined,
                      {
                        minimumFractionDigits: 2,
                        maximumFractionDigits: 2,
                      }
                    )
                  )
                    ? Number(totalOrderAmount / totalOrderCount).toLocaleString(
                        undefined,
                        {
                          minimumFractionDigits: 2,
                          maximumFractionDigits: 2,
                        }
                      )
                    : 0}
                </Typography>
              </div>
              <div className={classes.summaryDetail}>
                <Typography variant="subtitle1">
                  <strong>Average unique SKUs per order: </strong>
                  {!isNaN(
                    Number(
                      perOrderTotalUniqueSkuCount / totalOrderCount
                    ).toLocaleString(undefined, {
                      minimumFractionDigits: 2,
                      maximumFractionDigits: 2,
                    })
                  )
                    ? Number(
                        perOrderTotalUniqueSkuCount / totalOrderCount
                      ).toLocaleString(undefined, {
                        minimumFractionDigits: 2,
                        maximumFractionDigits: 2,
                      })
                    : 0}
                </Typography>
              </div>
              <br />
              <div className={classes.summaryDetail}>
                <Typography variant="subtitle1">
                  <strong>ORDER STATUS</strong>
                  {orderStatusesBreakdown.length === 0 ? (
                    <Typography variant="body1" color="textSecondary">
                      No order status to display.
                    </Typography>
                  ) : (
                    Object.keys(orderStatusesBreakdown).map((key) => (
                      <div key={key}>
                        <Typography variant="subtitle1">
                          {key}: {orderStatusesBreakdown[key]}
                        </Typography>
                      </div>
                    ))
                  )}
                </Typography>
              </div>
            </div>
          </Paper>
        </Box>
        {generateBreakdown()}
      </Dialog>
      <AppBar position="fixed" className={classes.appBar}>
        <Toolbar>
          <IconButton
            color="inherit"
            edge="start"
            onClick={props.handleDrawerToggle}
            className={classes.menuButton}
            size="large"
          >
            <MenuIcon />
          </IconButton>
          <Typography variant="h6" noWrap>
            {accountsLabel.singular} Orders
          </Typography>
          <div className={classes.flexGrow} />
          <IconButton
            className={classes.margin}
            onClick={menuHandleClick}
            edge="end"
          >
            <MoreVertIcon />
          </IconButton>
          <Menu
            id="simple-menu"
            open={openMenu}
            anchorEl={menuAnchorEl}
            onClose={() => {
              setMenuAnchorEl(null);
            }}
          >
            <MenuItem onClick={countTransactions}>
              Download {accountsLabel.singular} transactions
            </MenuItem>
            <MenuItem onClick={handleShowUpdateOrderStatusDialog}>
              Update order status via CSV
            </MenuItem>
            <MenuItem onClick={handleShowAssignDeliverieOrdersDialog}>
              Assign for deliveries
            </MenuItem>
          </Menu>
        </Toolbar>
      </AppBar>
      {search()}
      {isLoading ? (
        <LinearProgress
          color="secondary"
          style={{ marginLeft: ".1rem", marginRight: ".1rem" }}
        />
      ) : (
        ""
      )}
      {renderHeaderSummary()}
      {tabPanels()}
      <StyledEngineProvider injectFirst>
        <ThemeProvider theme={materialTheme}>
          {dateRangeFilterDialog()}
          {statusFilterDialog()}
          {CancelBookingReasonDialog()}
          {messageDialog()}
          {csvDownloadMessageDialog()}
          {orderStatusDialog()}
          {progressDialog()}
          {updateStatusDialog()}
          {downloadOrdersProgressDialog()}
          {salesManFilterDialog()}
          {accountDeleteProgressAndStatusDialog()}
          {assignOrderDeliveriesDialog()}
          {uploadCSVProgressDialog()}
          {orderMoreVertDropdownMenu()}
          {selectDeliveryPersonelDialog()}
          {errorMessageDialog()}
          {orderForPickingDialog()}
          <VanAccountItems
            openItemSummaryDialog={openVanAccountItemsDialog}
            setOpenItemSummaryDialog={setOpenVanAccountItemsDialog}
            itemSummaryDialogTitle={"Van Account items"}
            selectedTransaction={selectedVanAccountTransaction}
          />
        </ThemeProvider>
      </StyledEngineProvider>
    </div>
  );
}
